// AUTO-GERADO — nao editar manualmente.
// Fonte: vendor/berusky/data/Levels/*.lv3 (120 fases originais)
// Importador: tools/berusky/import-levels.mjs
// Re-rodar: node tools/berusky/import-levels.mjs

import type { FaseDef } from '../types';

export const LEVELS_BERUSKY: FaseDef[] = [
  {
    id: 3,
    nome: 'Bônus 01',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#.#####..###.......#####..###..#',
      '#...#...#...#.1....#...#.#...#.#',
      '#...#...#...#..........#.#.....#',
      '#...#...#...#.####....#..####..#',
      '#...#...#...#........#...#...#.#',
      '#...#...#.#.#.......#....#...#.#',
      '#...#...#..##......#.....#...#.#',
      '#.#####..###E......#......###..#',
      '#..........##..................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#.##.######.#..##.##..#.####.#.#',
      '#.#.##...#.#.#.#.##.##.#.#.###.#',
      '#.##.##..#.###.##.##.###.#.###.#',
      '#.#.##...#.#K#.#.##K##K#.#.###.#',
      '#.##K###.#.#.#.##.#.##.#####K#.#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 4,
    nome: 'Bônus 02',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#.#.#..##..###..#...#.#..#.###.#',
      '#.#.#.#.2#.K#...#...#.##4#.#...#',
      '#.###.#..#..#...#...#.#.##.##..#',
      '#.#.#.#..#..#...#...#.#..#.#...#',
      '#.#.#..##...#...###.#.#T.#.###.#',
      '#....1.........................#',
      '#..............................#',
      '#.#.#..##...##...##...##....#..#',
      '#.#.#.#.5#.#K.#.#..#.#K.#..##..#',
      '#.#K#.#..#.#....#..#.#..#.#.#..#',
      '#.###....#.###...##.....#..3#..#',
      '#...#..##..#..#.#..#..##....#..#',
      '#...#.#....#..#.#..#.#......#..#',
      '#...#.####..##...##..####.####.#',
      '#.T............................#',
      '#SSSSS.........................#',
      '#SE.B.........................B#',
      '#SSSSS.......................BK#',
      '################################',
    ],
  },
  {
    id: 5,
    nome: 'Bônus 03',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#................#.............#',
      '#.4..............#S##..........#',
      '#................#..##.........#',
      '#...............##...S.......3.#',
      '#.............M##..###.........#',
      '#.............##...##..........#',
      '#.............#.....#..........#',
      '#.............#.#M#.#..........#',
      '#.............#.#K#.#..........#',
      '#.............#B###.###........#',
      '#........######.T...KB#........#',
      '#........TBKB..K####T##........#',
      '#........######E#..#.#.........#',
      '#.............#K#..............#',
      '#............1#.#2.............#',
      '#............##.##.............#',
      '#.............#S#..............#',
      '#..5..........#.#..............#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 6,
    nome: 'Bônus 04',
    dificuldade: 'facil',
    mapa: [
      'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
      'S..............................S',
      'S.SSSSS..................SSSSS.S',
      'S.SK.MS...SSSSSSSSSSSS...SK.MS.S',
      'S.S...S...S..........S...S...S.S',
      'S.S...S...SSSSSSSSSSSS...S...S.S',
      'S.SSSSS..................SSSSS.S',
      'S..............................S',
      'S.......SSSSS......SSSSS.......S',
      'S..SSS..S..MS..SS..SK..S..SSS..S',
      'S..S.S..S.2.S.SSSS.S...S..S.S..S',
      'S..SSS..S..MS..SS..SM..S..SSS..S',
      'S.......SSSSS......SSSSS.......S',
      'S..............................S',
      'S.SSSSS..................SSSSS.S',
      'S.S...S...SSSSSSSSSSSS...S...S.S',
      'S.S...S...S..........S...S...S.S',
      'S.SM.KS...SSSSSSSSSSSS...SE.KS.S',
      'S.SSSSS..................SSSSS.S',
      'S..............................S',
      'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
    ],
  },
  {
    id: 7,
    nome: 'Bônus 05',
    dificuldade: 'facil',
    mapa: [
      '...........#############........',
      '.............B.........#........',
      '...........###########.#........',
      '#...................K#.#........',
      '#..............#######.#........',
      '#..............#.OK....#........',
      '##.............#.#####.#........',
      '.#.............#.#...#.#........',
      '.#.............#.#K..#.#........',
      '.#....##########.###.#.#........',
      '.#.1......T.O.....E#.#K#......##',
      '.#....##########O###.###......#.',
      '.#.............#.#...#K#......#.',
      '.#.............#.#...#.#......#.',
      '.#...........###.#...#.#......#.',
      '.#...........#...#...#.###....#.',
      '.#...........#.###...#........#.',
      '.###.........#.#.....#####..###.',
      '...#........................#...',
      '...#######..................#...',
      '.........####################...',
    ],
  },
  {
    id: 8,
    nome: 'Bônus 06',
    dificuldade: 'facil',
    mapa: [
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..............................B',
      'B............................5.B',
      'B...........BBBB...............B',
      'B...........B.BB...............B',
      'B...........BK.B...............B',
      'B...........BK.B...............B',
      'B...........BBBB...............B',
      'B...........B..B...............B',
      'B...........BBKB...............B',
      'B...........BBBB...............B',
      'B...........BK.B...............B',
      'B...........BB.B...............B',
      'B...........BBBB...............B',
      'B...........BB.B...............B',
      'B...........BK.B...............B',
      'B...........BE.B...............B',
      'B...........BBBB...............B',
      'B..............................B',
      'B..............................B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
    ],
  },
  {
    id: 9,
    nome: 'Bônus 07',
    dificuldade: 'facil',
    mapa: [
      '#.############################.#',
      '..#..........................#..',
      '###........##########........###',
      '#..........#.KE..EK.#..........#',
      '#..........#S######S#..........#',
      '#..............................#',
      '#..####.......###........####..#',
      '#..#K.#.......#K#........#..#..#',
      '#..#..#.......#.#........#TT#..#',
      '#..#.B#.....###.####.....##T#..#',
      '#..#B.B........TB...........#..#',
      '#..#.B#.....####.###.....##T#..#',
      '#..#..#........#.#.......#4M#..#',
      '#..#K.#........#K#.......#TT#..#',
      '#..####........###.......####..#',
      '#..............................#',
      '#..........#T######T#..........#',
      '#..........#B.....1.#..........#',
      '###........##########........###',
      '..#..........................#..',
      '#.############################.#',
    ],
  },
  {
    id: 10,
    nome: 'Bônus 08',
    dificuldade: 'facil',
    mapa: [
      'BBB##########################BBB',
      'BKB.a......................d.BKB',
      'BBB.###..................###.BBB',
      '#.....#.......BBBB.......#.....#',
      '#a#.3.........B..B.........5.#d#',
      '#.#...........BBBB...........#.#',
      '#.##........................##.#',
      '#..............................#',
      '###..........................###',
      '#.#...........####...........#K#',
      '#.............#..#.............#',
      '#E#...........####...........#.#',
      '###..........................###',
      '#..............................#',
      '#.##........................##.#',
      '#.#...........TTTT...........#.#',
      '#e#.4.........T..T.........1.#c#',
      '#.....#.......TTTT.......#.....#',
      'BBB.###..................###.BBB',
      'BKB.e......................c.BKB',
      'BBB##########################BBB',
    ],
  },
  {
    id: 11,
    nome: 'Bônus 09',
    dificuldade: 'facil',
    mapa: [
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..............................B',
      'B..............................B',
      'B..............................B',
      'B..............................B',
      'B..BBBB..##B#########B######...B',
      'B..BB.B..#.................#...B',
      'B..B.BB..#BB......###.###..#...B',
      'B..BB.B..#BB#.......#.#....#...B',
      'B..B.BB..B..#########.####.#...B',
      'B..BB.B..#....4JI5...B.....#...B',
      'B..B.BB..##############.####...B',
      'B..B.KB..B............#.#..B...B',
      'B..#Z#B..##########B#####B##...B',
      'B..............................B',
      'B..............................B',
      'BBBBB..........................B',
      'BK.K#..........................B',
      'B.E.Y..........................B',
      'BK.K#..........................B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
    ],
  },
  {
    id: 12,
    nome: 'Bônus 10',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#12#MO......................BK.#',
      '#43###.......................BK#',
      '#.5F.#........................B#',
      '####.#T........T...............#',
      '#.MB.#.........###.............#',
      '#O##.####......#.#.............#',
      '#.KB....#........#.............#',
      '####T##e########.#.............#',
      '#..B....BB....S#.#.............#',
      '#.#####.#####.##.#.............#',
      '#K#.OK#.#...#.##.##............#',
      '###.###.#..T#.....#............#',
      '#.E.....V...#.#####............#',
      '#########...###................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 13,
    nome: 'Fácil 01',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.T........................BBBB#',
      '#.1B....#####..............BKKB#',
      '#BBB....#...####...........BKKB#',
      '#.......#.#....##..........BBBB#',
      '#.......#.####..B..............#',
      '#.......#...T..##..............#',
      '#.......#.######...............#',
      '#.......#.#....................#',
      '#.......#.#....................#',
      '#.......#.#....................#',
      '#....####.######BB#............#',
      '#....B............#............#',
      '#....##############............#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#.T............................#',
      '####..........................T#',
      '#EBTB.......................B.K#',
      '################################',
    ],
  },
  {
    id: 14,
    nome: 'Fácil 02',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#4.......................M..S..#',
      '#################S############.#',
      '#.................#M.#.BS....#.#',
      '#..################..#.#...T.#K#',
      '#.T.B................SK#M...1#.#',
      '###########################S##.#',
      '#..SSS..#....MB..............T.#',
      '#...#...#....#S####.############',
      '#.K.#...#....#.#E.#M#...M#SS...#',
      '#...#.K.#....#.##S###....#KS.#.#',
      '#.B.#...###S##S..SS......#SS.#.#',
      '#.T.#BBB#....#########...###.#.#',
      '#SSS#..S#....#MMM#...#....3#5#.#',
      '#SSS#...#....#S#.#S#.#S#...#.#.#',
      '##S##SMT#....#.#S.M#..M#...#.#.#',
      '#..2#SSS#....#.#############M#.#',
      '#...#...#....#...............#.#',
      '#...#...#....#################.#',
      '#MMM#..SBT.....................#',
      '################################',
    ],
  },
  {
    id: 15,
    nome: 'Fácil 03',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '............####................',
      '............#..####.............',
      '..........###.....####..........',
      '.......####...TT.....#..........',
      '......##......T.T....###........',
      '......#......####......##.......',
      '......#.....##..##4.E...#.......',
      '......##..BB#....####...#.......',
      '.......##BBB#.......#...##......',
      '........#BBB###.....#..T.#......',
      '........##BBKK####.##..T.#......',
      '.........#BBBKK.B###...T.#......',
      '.........##TBBKB.BB....#.#......',
      '..........####BBBBBB.#####......',
      '.............####BB###..........',
      '................#TT#............',
      '................####............',
      '................................',
      '................................',
    ],
  },
  {
    id: 16,
    nome: 'Fácil 04',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#EK..1#........................#',
      '#####.#....##.#.#.###.#..#..#..#',
      '#....GF...#...#.#..#..##.#.#.#.#',
      '#.#####2#.#...###..#..#.##.###.#',
      '#.#.....#.#...#.#..#..#..#.#.#.#',
      '#.#.#.#.#..##.#.#.###.#..#.#.#.#',
      '#.#T#T#T#......................#',
      '#.#.#.#.#......................#',
      '#.#B#B#B#.####################.#',
      '#.#K#K#K#.#..................#.#',
      '#.#T#B#B#.#..................#.#',
      '#.#.#.#.#.#..................#.#',
      '#.#M...M#.#.............T....#.#',
      '#.#T#.#...#4.T..........TT...#.#',
      '#.#.#.....#TTTT.......TTTT...#.#',
      '#.#B####..#TTTTT......TTTTT5.#.#',
      '#SS.B.K#..#TTTTT.....TTTTTTT.#.#',
      '#.#T####..####################.#',
      '#.#.#..........................#',
      '################################',
    ],
  },
  {
    id: 17,
    nome: 'Fácil 05',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.............#....B#..BBMB....#',
      '#.SS..........#.##..#..BB.T..4.#',
      '#.S.S.........#.....TBBB###....#',
      '#.SS..SSS.....#######...#M#....#',
      '#.S.S..S...........#KBB.#M#....#',
      '#.S.S..S..S.S......##.B.#.SBS..#',
      '#......S..S.S.......########SS.#',
      '#.....SSS.S.S..S...........#KSS#',
      '#.........S.S.S.S..........#####',
      '#..........S..SSS..............#',
      '#.............S.S..............#',
      '######........S.S..............#',
      '#....##..............###########',
      '#B.B..#..............#.....T...#',
      '#BBB.B#######........#TSBSBSSS.#',
      '#B3BT....B.K#........#.S.S.S...#',
      '#BBB...B..B.#........#BS.SBS.SS#',
      '#BBB.#.B.BKB#........#.S.S.S..S#',
      '#BEB.BTBT.B.#........#KS1S.SS2S#',
      '################################',
    ],
  },
  {
    id: 18,
    nome: 'Fácil 06',
    dificuldade: 'facil',
    mapa: [
      '######################...#K#....',
      '#.1..#...T...........#...#.#....',
      '#....T...###########.#...#.###..',
      '#######T##.........#.#...#...#..',
      '......#.#..........#.#...###.#..',
      '#####.#.#...########B##....#.#..',
      '#...#.#.#...#.........#....#.###',
      '#...###.#...#.#####..K#....#...K',
      '#......B#...#.#...#####....#B###',
      '#...###.#...#.#............#.#..',
      '#K..#.#.#...#.#....####....#.#..',
      '#####.#.#...#.#....#..######.#..',
      '......#.#...#.#....#....T.T..#..',
      '......#.#...#.#....#K.###.#..#..',
      '#####.#.#...#.#....####.#.#..#..',
      '#...#.#.#...#.#.........#.####..',
      '#...###.#####.##...######.#.....',
      '#...B..B..B....#...#......#.....',
      '#...#######....#...#.######.....',
      '#E..#.....#K...#...#.#..........',
      '#####.....######...#3#..........',
    ],
  },
  {
    id: 19,
    nome: 'Fácil 07',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '......####################......',
      '......#..B...B.........#.#......',
      '......#.E.#..#....###..#K#......',
      '......#...#BBX.T..#.B..H.#......',
      '......#####.K#.T..#KB..###......',
      '......#...######.T##B#...#......',
      '......#.3.......BBB#.T...#......',
      '......#...B.....B.K#...BK#......',
      '......####################......',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 20,
    nome: 'Fácil 08',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '..........######................',
      '....#######..#.#############....',
      '....#.....#..d.#.......#.K.#....',
      '....#..1..#.##.#.......#.B.#....',
      '....#.....#.##.#...#...#BBB#....',
      '....#M...M#..a.....#...#...#....',
      '....###.###..#.....#.......#....',
      '....#K#.#....#.....####O####....',
      '....#.S.#.#..#S#####.......#....',
      '....#.#...#..#K#K..#...#...#....',
      '....############BBB#...#...#....',
      '....#................T.#.4.#....',
      '....#K..........#.#.#E##...#....',
      '....########################....',
      '...................#####........',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 21,
    nome: 'Fácil 09',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '......###................###....',
      '.....##.##..............##.##...',
      '....##...####.........###K.B##..',
      '...##.B.....####...####TBBBB.#..',
      '...#..B........#####...B.....#..',
      '..##.BB................BKBBB##..',
      '..#KB.BB.......##B#....BBB..#...',
      '..#.BKB.B.....##..###.......#...',
      '..#..BBB.######.....####....#...',
      '..##BK..##.............####.#...',
      '...######......E..........#.##..',
      '...........#####........###..#..',
      '...#########...#####...##....#..',
      '..##...............#####.....#..',
      '..#2......TT#..............###..',
      '..##......TB#####.........##....',
      '...##########...###########.....',
      '................................',
      '................................',
    ],
  },
  {
    id: 22,
    nome: 'Fácil 10',
    dificuldade: 'facil',
    mapa: [
      'B.B.#BB.............BB2BB....BK#',
      '.B.B#1#..............BBB....BTM#',
      'BKB.#BT...###S##..T...BB....B.B#',
      '.B.B#.....#KT..#.............B.#',
      'BTB.#M#...#B.T.#...............#',
      '.B.B##########################B#',
      'B.B.S..........................#',
      'KB.BSB##########################',
      'B.B.S...................T.......',
      '.B.BS......................T....',
      'BTB.SB##########################',
      '.B.BST..........................',
      'B.B.SB##########################',
      '.B.BS..........................#',
      'B.B.S########################..#',
      '.BTBS..........................#',
      'B.B.S.########################.#',
      '.B.BS..............T...........#',
      'B.B.S#########################B#',
      'EB.BS.......KMMS...............#',
      'B.B.############################',
    ],
  },
  {
    id: 23,
    nome: 'Fácil 11',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#......BB..B..BB..B.B.B........#',
      '#.45..B...B.B.B.B.B.B.B........#',
      '#......B..B.B.BB..B.B.B........#',
      '#.......B.B.B.B.B.B.B.B........#',
      '#a#...BB.K.B..BB...B.KBBB....#b#',
      '#.#...###################....#.#',
      '#.#...B#1..#2..#3..##..#B...##.#',
      '#.#...T#T#B#T#B#T#B#T#B#T...#..#',
      '#K#...B#...#...#...#...#B...#.##',
      '#K#...###.###.###.###.###...#..#',
      '#K#......B...B...B...B......##.#',
      '#.#.........................#..#',
      '#.#.........................#.##',
      '#.#............#c#..........#..#',
      '#.#............#.#..........##.#',
      '#.#.........####T###........#..#',
      '#.#.........#BEB.#B#........#.##',
      '#.###########BB..b.##########..#',
      '#.............T.B#.............#',
      '################################',
    ],
  },
  {
    id: 24,
    nome: 'Fácil 12',
    dificuldade: 'facil',
    mapa: [
      '###########.........#.#.........',
      '#...B...BK#.........#.#.........',
      '#.4.B...BB#.........#.#.........',
      '#..BBBBBB.########..#.#.########',
      '#BBBT....B.O.....#..#.#.#.......',
      '#.........######.####.###.######',
      '#...BBB...#....#..........#.....',
      '#..#...#..#....#.##########.....',
      '#.B..B..B.#....#.#..............',
      '#.B.BTB.B.#....#.#..............',
      '#.B..B..B.#....#.#..............',
      '#..#...#..#....#.#...###########',
      '#...BBB...#....#.#...#BB.BK.B.K#',
      '#.........#....#.#####TTBB..B..#',
      '#..BBBBB..#....#....O..TBBBBBBB#',
      '#.B..B..B.#....#.#####......B..#',
      '#.BBB.BBB.#....#.#...#.....BB.K#',
      '#.B..B..B.#..###.#...#.....BBBB#',
      '#.B.B.B.B.#..#...#...#.....BBEB#',
      '#.B.BKB.B.#..#.###...#.....BBBB#',
      '###########..#.#.....###########',
    ],
  },
  {
    id: 25,
    nome: 'Fácil 13',
    dificuldade: 'facil',
    mapa: [
      '............#####...............',
      '........#####...#...............',
      '........#.......######..........',
      '......###..####......#..........',
      '......#.......#.##.#.####.......',
      '....###..#..#......#.#..#.......',
      '....#3...#####.###.#.#..###.....',
      '....#.#.....#KSK#..#.#....#.....',
      '....#...#...#KKK#....#.##.#.....',
      '....#.###.#####S#.####..#.#.....',
      '....#.....#............##.#.....',
      '....#####.T.###.#...#..#..#.....',
      '.......#..###.#.##..#.....#.....',
      '.......#......#........#..#.....',
      '.......#####..#####.#######.....',
      '...........#......#.#EMB#.......',
      '...........#...####.###.#.......',
      '...........##.##..#.#...#.......',
      '............#...........#.......',
      '............##.........##.......',
      '.............###########........',
    ],
  },
  {
    id: 26,
    nome: 'Fácil 14',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#1B....BBB.BB..................#',
      '#.B......BB.B..................#',
      '#.B..BBB.B.B..........BBBB.....#',
      '#.BBBB.BB.B........BBB.B.BB....#',
      '#.B..BBB.BBB......B.BB..BBB....#',
      '#BBBBBK..B.KB......B.BB.B.B....#',
      '#B.B.BBBBB.BB........BBB.BBB...#',
      '#.BB.B.B.BBB......BBBBK..BB.B..#',
      '#.......B..BBB....B..BBB.B.B...#',
      '#.......BBBB......BB..BB.BB....#',
      '#.................B.BB.KBBB....#',
      '#..................BB..BBB.B...#',
      '#..BB.B..............BB..BBB...#',
      '#BBBBBB.B..........BB.BB.......#',
      '#B.BB.BBB............B..B......#',
      '#.B.BB.EB......................#',
      '#B.K.B.BB......................#',
      '#.BBB.BBB.B....................#',
      '#.B............................#',
      '################################',
    ],
  },
  {
    id: 27,
    nome: 'Fácil 15',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '..1.............................',
      '..............BBBBBB............',
      '.....BBBTBB...BTTBKT............',
      '.....T.TTEB...TBB.BB............',
      '.....TBTTTT...BB.TBB............',
      '.....B.TBTB...TTK.TB............',
      '.....BBB.BT...TBBTTB............',
      '.....BBBTTB.....................',
      '................................',
      '................................',
      '................................',
      '.....#BB######.........BBBBBB...',
      '.....#BBB.BBB#.........BBBBBB...',
      '.....#BB#K#BB#.........BBKBBB...',
      '.....######BB#.........BBBKBB...',
      '.......................BBBBBB...',
      '.......................BBBBBB...',
      '................................',
      '................................',
    ],
  },
  {
    id: 28,
    nome: 'Fácil 16',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.....O.......#.......b........#',
      '#O###########.#.......#........#',
      '#......O....1.d.......#........#',
      '#.#############.......#........#',
      '#.....O.......#.......#........#',
      '#O###########.#.......#........#',
      '#......O....4.c.......#........#',
      '#.#############.......#........#',
      '#.....O.......#......KBK.......#',
      '#O###########.#######BEB########',
      '#......O....3.b......KBK.......#',
      '#.#############.......#........#',
      '#.....O.....5.#.......#........#',
      '#O###########.#.......#........#',
      '#......O....2.e.......#........#',
      '#.#############.......#........#',
      '#.....O.......#.......#........#',
      '#############.#.......#........#',
      '#K.....O......a.......a........#',
      '################################',
    ],
  },
  {
    id: 29,
    nome: 'Fácil 17',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#........######................#',
      '#..##..T...B.E#......BBB.......#',
      '#...#..#...B.K##.....#.B.......#',
      '#...#.#####.B..##B...#.###.....#',
      '#..####...##BBBBBBB..#K..B.....#',
      '#..B....B..B...B..######.B.....#',
      '#..TB.#BBBB....BBB...#.BBB.....#',
      '#..B..#...#.....B..#K#.........#',
      '#..####.BB##...#######.........#',
      '#..#....K..#.....#.............#',
      '#..#########.....#.............#',
      '#..............................#',
      '#.##B##........................#',
      '#.#...##.......................#',
      '#.#KB.B#.......................#',
      '#.##.B.##......................#',
      '#..#BBBB.....................1.#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 30,
    nome: 'Fácil 18',
    dificuldade: 'facil',
    mapa: [
      '.############################...',
      '.#.31.........#BK...B#......#...',
      '.#..BT....B.B.#.BB.B.#..B...#...',
      '.#.B...B.B.BBB#K..B..#....B.#...',
      '.#....B.BB.B.B##.BBB##.B.TB.#...',
      '.#..BB.B.....B.#B.B.#..B.B..#...',
      '.#....B..BBB.B.#...B#..BB...##..',
      '.#.###.B..B....##BB##BB.BBB..#..',
      '.###.#...B.B...#.B..B.B...B..#..',
      '.....#B.BB.BB.B.B...B..B....##..',
      '..####.B..B..B.B.B.B.B..B.B.#...',
      '.##..#...BB...B.B.B.BB...B..#...',
      '.#.....BB..B.B.B.B.B....B.B.#...',
      '.#.......B...B.BB.B.B..BB...####',
      '.##...B.B.BB.B.B.B.BB......B...#',
      '..#..#..BB...B.B.B...B..B..#B..#',
      '..#.B.....B.BB..B.B.B.BBBB.#...#',
      '..##...BB..#.....B.B.B.....###M#',
      '...###....#E#####.#...BB..B....#',
      '.....#....#SKKK...##############',
      '.....###############............',
    ],
  },
  {
    id: 31,
    nome: 'Fácil 19',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#1B..........................B2#',
      '#BBB........................BBB#',
      '#.BBBBBBBBBBBBBBBBBBBBBBBBBBBB.#',
      '#..BBB....................BBB..#',
      '#..BBBBBBBBBBBBBBBBBBBBBBBBBB..#',
      '#..B.BBB................BBB.B..#',
      '#..B.BBBBBBBBBBBBBBBBBBBBBB.B..#',
      '#..B.B.BBB....SSSS....BBB.B.B..#',
      '#..B.BKBB....SSSSSS....BBKB.B..#',
      '#..B.B.BM....SSKESS....MB.B.B..#',
      '#..B.BKBB....SSSSSS....BBKB.B..#',
      '#..B.B.BBB....SSSS....BBB.B.B..#',
      '#..B.BBBBBBBBBBBBBBBBBBBBBB.B..#',
      '#..B.BBB................BBB.B..#',
      '#..BBBBBBBBBBBBBBBBBBBBBBBBBB..#',
      '#..BBB....................BBB..#',
      '#.BBBBBBBBBBBBBBBBBBBBBBBBBBBB.#',
      '#BBB........................BBB#',
      '#3B..........................B4#',
      '################################',
    ],
  },
  {
    id: 32,
    nome: 'Fácil 20',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.........#..........#.........#',
      '#.........#..........#.........#',
      '#.........#..........#.........#',
      '#...BBB...#..........#...BBB...#',
      '#...BKB..................BKB...#',
      '#...BBB...#..........#...BBB...#',
      '#.........#..........#.........#',
      '#.........#......BBTB#.........#',
      '#.........#......B..K#.........#',
      '#####.####################.#####',
      '#.........#..........#.........#',
      '#.........#..........#.........#',
      '#.........#..........#..TT.....#',
      '#...BBB...#..........#..TBBB...#',
      '#...BEB.......BBB........BKB...#',
      '#...BBB...#...B.B....#..TBBB...#',
      '#.........#BBBT.B....#..TT.....#',
      '#.........#BB.B.B....#.........#',
      '#1........#KB.B.B....#.........#',
      '################################',
    ],
  },
  {
    id: 33,
    nome: 'Fácil 21',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '..############################..',
      '..#........#...#..B.#..B...B5#..',
      '..#B...###.B.#.#.EB.#.B#..#..#..',
      '..#BB....#M###.#.BB.#..##B#B.#..',
      '..#..BB..###...#.B...B.....B.#..',
      '..#..BB....#...##BBT##.#######..',
      '..#.BB.BB..#....#........B..B#..',
      '..#BBK.BBBK#.T...##.###.B#BB.#..',
      '..#..B...BB###....#.#...B#.BK#..',
      '..#..BB...B#K#....#.#...##.BK#..',
      '..#.B..BB..#.###..#.#....B.B.#..',
      '..#BB..BB..#.B.#......#S######..',
      '..#B.BBB.BB#B.B#..#...#...B..#..',
      '..#...BB.B.#.B....#...#..#T1.#..',
      '..#2.......#B.B.......#..#BT.#..',
      '..############################..',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 34,
    nome: 'Fácil 22',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#.1............................#',
      '#..............................#',
      '#..............######.######...#',
      '#..............#...........#...#',
      '#....BBB.......#...........#...#',
      '#..BBBKBB......#..#####.#..#...#',
      '#..B.KB.B......#....B.B.#..#...#',
      '#..B.B.B.......#..#B.B.B#..#...#',
      '#..BBBBB..........#.BEBK#......#',
      '#..............#..#B.B.B#..#...#',
      '#..............#..#.BKB....#...#',
      '#..............#..#.#####..#...#',
      '#..............#...........#...#',
      '#..............#...........#...#',
      '#..TT..........######.######...#',
      '#T.TT..........................#',
      '#.TK...........................#',
      '#.TT...........................#',
      '################################',
    ],
  },
  {
    id: 35,
    nome: 'Fácil 23',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#SMMMMMMMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMKMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMMMMMMMMMMMMMMMMMMKMMMM#',
      '#MMMMMMMMMMMMMMMMMMMMMM2MMMMMMM#',
      '#MMMMMMSMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMMMMMM5MMMMMMMMMMMMMMMM#',
      '#MMM1MMMMMMMMMMMMMMMMMMMMSMMMMM#',
      '#MMMMMMMMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMMSMMMMMMMMMMMMMMMMMMMM#',
      '#MMMSMMMMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMSMMMMMMMMMMMMMSMMMMMMMMMMMMM#',
      '#MMMMMMMMSMMMMMMMMMMMMMMMM3MMMM#',
      '#MMMMMMMMMMMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMSSMMMMMMMMMMMMMMMMMMMM#',
      '#MMMMMMMMSMMMMMMMMMMMMMMMMMMMMM#',
      '#MM4MMMMMMMMMMMMMMMKMMMMMMMMMMM#',
      '#MMMMMMMSSMMMKMMKMMMMMMMMMMMMMM#',
      '#EMMMMMMMMMMMMMMMMMSMMMMMMMMMMM#',
      '################################',
    ],
  },
  {
    id: 36,
    nome: 'Fácil 24',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#5B#........................#B3#',
      '#BB..........................BB#',
      '#..############..############..#',
      '#BB#T......................T#BB#',
      '#KB#........................#BK#',
      '####........................####',
      '#...B.##B##..........##B##.B...#',
      '#.#.B.#...#....BB....#...#.B.#.#',
      '#.#.B.#...#..BBBBB...#...#.B.#.#',
      '#.TBB.#BTB#..BBEBBB..#BTB#.BBT.#',
      '#.#.B.#...#..BBB.BB..#...#.B.#.#',
      '#.#.B.#...#...KBBB...#...#.B.#.#',
      '#...B.##B##..........##B##.B...#',
      '####........................####',
      '#.K#........................#K.#',
      '#.T#T......................T#T.#',
      '#..############..############B.#',
      '#..T........................T..#',
      '#..#........................#..#',
      '################################',
    ],
  },
  {
    id: 37,
    nome: 'Fácil 25',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............#...............#',
      '#.4............#...............#',
      '#..............#.##............#',
      '#..............#.#.............#',
      '#..............#.#.............#',
      '#..........BBB.#B#K............#',
      '#....#######.###B###...........#',
      '#....#.....#E#.....#BB.BB......#',
      '#....#..TTT###.....##########B##',
      '#..................BB..........#',
      '#....#..TTT###.....#########.#.#',
      '#....#...BK#.#.....#......#..#.#',
      '#....#######K###B###......#..#.#',
      '#..........BBB.#B#......BB#..#.#',
      '#..............#.#K....###...#.#',
      '#..............#.##..###B....#.#',
      '#..............#.......BBB...#.#',
      '#..............#.....##B.K####.#',
      '#............BB#.....B#........#',
      '################################',
    ],
  },
  {
    id: 38,
    nome: 'Fácil 26',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '################################',
      '#####.###3###.####.###5###.#####',
      '#####.....###.#SS#.###.....#####',
      '#####..........SS..........#####',
      '##KBB.....E...####...E.....BBK##',
      '##KBB....###........###....BBK##',
      '#####....#.##......##.#....#####',
      '#######..#..###..###..#..#######',
      '#######..##...####...##..#######',
      '####S##...#..........#...##S####',
      '#######..##...####...##..#######',
      '#######B.#..###..###..#.T#######',
      '#####..B.#.##......##.#.T..#####',
      '##..TBTB.###........###.TBTB..##',
      '##...T........####........B...##',
      '#####T......BB.SS.BB......B#####',
      '#####.....###B#SS#B###.....#####',
      '#####.###2###K####K###4###.#####',
      '################################',
      '################################',
    ],
  },
  {
    id: 39,
    nome: 'Fácil 27',
    dificuldade: 'facil',
    mapa: [
      'SSSSSSSSSS###SSSSSSSSSSSSSSSSSSS',
      'SSSSSSSSSS#E######SSSSSSSSSSSSSS',
      'SSSSSSSSSS#..K...#SSSS...KSSSSSS',
      'SSSSSSSSSS######.#SSSS.SSSSSSSSS',
      'S.......SS#..K...#SSSS.SSSSSSSSS',
      'SSSSSSS.###.######SSSS.....SSSSS',
      'SSSSSSS.O....K...O....KSSS.SSSSS',
      'SSSSSSS.#######O##SSSSSSSS.SSSSS',
      'SSSSSSS.SSSSSSSSS#SSSSSSSS.SSSSS',
      'SS......SS.21MM..b.......S.SSSSS',
      'SS.SSSSSSS.SSSSSS#SSSSSS.S.SSSSS',
      'SS.SSSSSSS.SSSSSSSSSSSSSS..SSSSS',
      'SS..SSSSSSSSSSSSSSSSSSSS.SSSSSSS',
      'SSS.SSSSSS.SSSSSS....S...SSSSSSS',
      'SSS.SSSSSS.SSSSSS.SSSSSS.SSSSSSS',
      'SSS.SSSSSS.SSMSSS.SSSSSS.....SSS',
      'SSS.SSSSSS.SS.SSS.SSSSSSSSSS.SSS',
      'SSS...MSSS.SS.SSS.SSSSSSSSSS.SSS',
      'SSSS.SSSSS.SS.SSS.SSSSSSSSSS.SSS',
      'SSSS...S........S.SSSSSSSSSS.SSS',
      'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
    ],
  },
  {
    id: 40,
    nome: 'Fácil 28',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#.BBB.BBB.BB..B..B..BB.B.B.B.B.#',
      '#.B.B.B...B.B.B..B.B...B.B.B.B.#',
      '#.BB..BB..BB..B..B.BBB.BB..B.B.#',
      '#.B.B.B...B.B.B..B...B.B.B..B..#',
      '#.BBB.BBB.B.B..BB..BB..B.B..B..#',
      '#..............................#',
      '#.############################.#',
      '#.#KSB...#...BB2#BB#3S.#..M#4#.#',
      '#.#SSSB..S.BB.BM#BK#M#S#.#.#.#.#',
      '#.#BBSB..#.B.B..####B#.S.#.#.#.#',
      '#.#B1B.B.#.S..###..#.#.#S#.#.#.#',
      '#.#MBSS..#..##..#..#.#.#.S...#.#',
      '#.#.S.S..#S#.#.TS....#.#..SM##.#',
      '#.#MMMS.M#...#.#####...#E..S.#.#',
      '#.##########.#..##..########S#.#',
      '#..........#.#....#........#K#.#',
      '#.........##B####.#.......#5K#.#',
      '#.........#....T..#......#KKE#.#',
      '################################',
    ],
  },
  {
    id: 41,
    nome: 'Fácil 29',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.....#.##.......T.T.T.T.T.....#',
      '#.....#1..#.....T.T.T.T.T.T....#',
      '#.....###..#....T5TKTKTKTKT....#',
      '#........#..#...T.T.T.T.T.T....#',
      '#........#.T#...T.T.T.T.T.T....#',
      '#........#..#....T.T.T.T.T.....#',
      '#........#..#..................#',
      '#........#...#.................#',
      '#........#...#.......########..#',
      '#........#..#E.......#MB...T.#.#',
      '#........#..#########BBB####.#.#',
      '#...###..#.#3..M....MBKB...#.#.#',
      '#..#...#.#.######.##SBBB...#.#.#',
      '#..#.#..#SB......M#........#.#.#',
      '#..#..#..#S######.########.#.#.#',
      '#...#.##.#.##...#...SS...#.#.#.#',
      '#...#2T..B..#...########.#.#.#.#',
      '#...######..#..........#.###.#.#',
      '#........#.#...........#4....#.#',
      '################################',
    ],
  },
  {
    id: 42,
    nome: 'Fácil 30',
    dificuldade: 'facil',
    mapa: [
      '........#....B#.................',
      '..B.....#KB..B#....###########..',
      'SS####.####S###....#.#.......#..',
      '....#.......#....###.#...TBT.#..',
      '...M#.......#....#.B.e...B#B.#..',
      '#############....#KB.#...TBT.#..',
      '.................###.#.......#..',
      '.................#KB.a.123.45###',
      '.................###T#.........#',
      '...#######O#######.............#',
      '...#...................#a##b##c#',
      '...#..T...T............T.......#',
      '...#BBBBBBBBBBBBBBBBBBBBBBBBBBB#',
      '...#######E#############K##K##K#',
      '...#.....###...........#########',
      '...#...........................#',
      '#..#############################',
      '##..............................',
      'K#.....................#########',
      '.###.............#######.B.#..BB',
      '...#.............#K......B......',
    ],
  },
  {
    id: 43,
    nome: 'Fácil 31',
    dificuldade: 'facil',
    mapa: [
      '.##############################.',
      '##.TBTBTBTBTBTBTBTB#......#B.B##',
      '#T4...............T#.###..#.E#.#',
      '#K###############.B#.#....#B##.#',
      '#B#...............T#.....##.#..#',
      '#T#.BBBB.TBTBTBTBTB####........#',
      '#B#.B..B.B##########....###.#.##',
      '#T#.BBBB.T#BBBBBBBB#..#.#......#',
      '#B.......B#BBBBBBBB##.#.###.##.#',
      '#T#TBTBTBT#B.TBBBBB#......#.#..#',
      '#B#B#######B.T.BKBB##.##..###..#',
      '#TBT#.BB.B#BBTB.BBB#...........#',
      '#####BBBB.#BB.....B#....#.####.#',
      '#.TB#.BBK.#BBBBBBBB###..#.#..#.#',
      '#.1T#.BB.B#BBBBBBBB#.#.##....#.#',
      '#BTB#BB.B.#BBBBBBBB#...#.......#',
      '#.###B.B.B#BBBBBBBB#####.##..###',
      '#TB.#.B.BK#BBBBBBBB#.T....##.#.#',
      '#.BK#.2BB.#TTTTTTTT#.##......5.#',
      '##..#B..BB#3.......#..........##',
      '.##############################.',
    ],
  },
  {
    id: 44,
    nome: 'Fácil 32',
    dificuldade: 'facil',
    mapa: [
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B3.B##BK.B..B...B..B##B..B..B.KB',
      'B..B##B..B..B...B..B##B..B..B..B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..B..B..BTTB...BSSB..B..BTTB..B',
      'B..B..B..BTTB...BSSB..B..BTTB..B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..B..B##B..BSSSB..B..B##B.KB..B',
      'BK.B..B##B..BSSSB..B..B##B..B..B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'BTTB..B..B##B...BTTB..B..BSSB..B',
      'BTTB..B..B##B...BTTB..B..BSSB..B',
      'BTTB..B..B##B...BTTB..B..BSSB..B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..B..B..B..B...B..BSSB..B..BTTB',
      'B..B..B..B..B...BK.BSSB..B..BTTB',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
      'B..B..BTTB..BTTTB..B..B..BSSB..B',
      'B..B..BTTB..BTTTB..B..B..BSSB..B',
      'BE.B..BTTB..BTTTB..B..B..BSSB..B',
      'BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB',
    ],
  },
  {
    id: 45,
    nome: 'Fácil 33',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.......#T#.#TTT#..............#',
      '####....#T#.#TTT#.######.......#',
      '#SS####K#T#.#####K#SSSS#.#####.#',
      '#SSSSS#.###K......#SSSS#.#TTT#.#',
      '#######..K..#####K##SSS#.#TTT#.#',
      '#..K....###.#SSS#..#####.#TTT#.#',
      '#.#########.###S#..K....K#####K#',
      '#.#########...#S###.......K....#',
      '#.#########.###SSS#.#######....#',
      '#.###.......#SSS###.#######....#',
      '#.###.####KK#####...#######..###',
      '#.###.####...K...K...K.####.##B#',
      '#.###.####.###...#####.....K#BB#',
      '#.###.####K#S#...#####.####.#BB#',
      '#.###.####.#S#...#####.#TT#.####',
      '#...K......#S###K#####K##T#.E..#',
      '#...###..###SSS#.#####..#T###..#',
      '#...#T##.#SSSSS#..####..#TTT#..#',
      '#3..#TT#.#SSSSS#........#TTT#.K#',
      '################################',
    ],
  },
  {
    id: 46,
    nome: 'Fácil 34',
    dificuldade: 'facil',
    mapa: [
      '#####.....#.#...............#.#.',
      '#BB.#...###.#........########.#.',
      '#..B#...#...#........#...O....#.',
      '#B..#...#.###........#.########.',
      '#...#...#O#..........#.#........',
      '#.B.#...#.#..........#.#........',
      '#O#B#####.########.###.##.......',
      '#KB..B...B...B2B.#.#....#.......',
      '#BKB....BBB......#.#.B..#.......',
      '#############.B..###.B..#.......',
      '#......#....#B.B.....B..#.......',
      '#.####.#....#KB......B..########',
      '#.#..#B#....#B.B######..B...B..B',
      '#O#..#.######.B.#....#..B..T.BK.',
      '#.#..#T#.......B#....#B.....####',
      '#.####K#.####...#....#KB..BB#...',
      '#..TBB...#..#...#..###B.....#...',
      '#####K####..#...####....TT..####',
      '....#.#.#####......B....TT...BB.',
      '....#O#.#EBTB............T..BBB.',
      '....#.#.########################',
    ],
  },
  {
    id: 47,
    nome: 'Fácil 35',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#K......#2.....................#',
      '#BBBBB..#......................#',
      '#.......#......................#',
      '#..BBBBB######.................#',
      '#...T...K#1..#.................#',
      '#..BBB..#MBBB##############....#',
      '#B.....#TBBT..............#....#',
      '#..BBBB#..................#K.B.#',
      '#......#.................####.##',
      '#BBB...#.................B..#..#',
      '#....BB###################...#.#',
      '#BBBBBBE.................#...#.#',
      '#....#B#################.#...#.#',
      '#....#.B...............#B#...#.#',
      '#....#.B...............#.#...#.#',
      '#BBB.#.B.................#...#.#',
      '#......BT...............#...K#.#',
      '#.......................SB####.#',
      '#K...#..................#BT....#',
      '################################',
    ],
  },
  {
    id: 48,
    nome: 'Fácil 36',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#1SSS#........#E#.........#.KKK#',
      '#.S..#.........M..........#....#',
      '#.S..######...K.K....######....#',
      '#....MMMMM#..........#MMMMM....#',
      '#########M#####.T#####M#########',
      '........#M....#B.#....M#........',
      '.##..#.###.BB.#TS#.BB.###.#..##.',
      '#..#.#.#.#B..B#SB#B..B#.#.#.#..#',
      '#..#.#.#.#..B.#ST#..B.#.#.#.#..#',
      '#..#.##..#.B..#BS#.B..#.##..#..#',
      '#..#.#.#.#B..B#TS#B..B#.#.#.#..#',
      '#..#.#.#.#.BB.#SB#.BB.#.#.#.#..#',
      '.##..#.###....#ST#....###.#..##.',
      '........#M.BB.#BS#.BB.M#........',
      '#########M#####TS#####M#########',
      '#....MMMMM#SS......SS#MMMMM....#',
      '#....######S.........######....#',
      '#....#....................#....#',
      '#.............#E#..............#',
      '################################',
    ],
  },
  {
    id: 49,
    nome: 'Fácil 37',
    dificuldade: 'facil',
    mapa: [
      '.#.#........##.##.........#.#...',
      '.#.#.###....#..K#....###..#.#...',
      '##.###.#....##B##....#.####.####',
      '...B..K#....#B.B#....#K...B.....',
      '##.###.#...#B.B.B#...#.####.####',
      '.#.#.###..#B.B.B.B#..###..#.#...',
      '.#.#.....#B.B.#.B.B#......#.#...',
      '.#.#.####B.#.B.B.#.B####..#.#...',
      '##.###.#B.B.B...B.B.B#.####.####',
      '.1.K.....B.B..EK.B.B.B..........',
      '##.###.#B.B.B...B.B.B#K####.####',
      '.#.#.####B.#.B.B.#.B####..#.#...',
      '.#.#.....#B.B.#.B.B#......#.#...',
      '.#.#......#B.B.B.B#.......#.#...',
      '.#.#.###...#B.B.B#...###..#.#...',
      '##.###.#....#B.B#....#.####.####',
      '...B..K#....##B##....#K...B.....',
      '##.###.#....#K..#....#.####.####',
      '.#.#.###....##.##....###..#.#...',
      '.#.#.........#.#..........#.#...',
      '.#.#.........#.#..........#.#...',
    ],
  },
  {
    id: 50,
    nome: 'Fácil 38',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.....#12345B#T.T.B.##....#SB..#',
      '#..#............T.T.....T..SB.K#',
      '########B#######################',
      '#.......B......................#',
      '#.....................###......#',
      '#.....................#K#......#',
      '#...................###B###....#',
      '#....................FGHIJ.....#',
      '#.MM.................#SSS#..KK.#',
      '######Y#########################',
      '#...#..#........S..............#',
      '#.#.#.B#.....###S##.###.######.#',
      '#.###.B#..#..BKSSS.............#',
      '#...#.....#..BMSSS...#...#.....#',
      '#......#....####E##..#...#####.#',
      '#......#..#....SSS...#.B.....#.#',
      '#.###..#..#..........#.BT....#.#',
      '#...#.....#...####.....B.#####.#',
      '#...#..#.......................#',
      '################################',
    ],
  },
  {
    id: 51,
    nome: 'Fácil 39',
    dificuldade: 'facil',
    mapa: [
      '###.########################.###',
      '#5#.#......................#.#1#',
      '#M###......................###M#',
      '#B............SSS.............B#',
      '###...........SKS............###',
      '..#...........SSS............#..',
      '###..........................###',
      '#..............................#',
      '#..SSSSS.BBBBBB.BBBBBB.SSSSS...#',
      '#..SMSMS.BBB..B.B..BBB.SMSMS...#',
      '#..SSKSS.B.T.BB.BB.T.B.SSKSS...#',
      '#..SSSSS.B..B.B.B.B..B.SSSSS...#',
      '#..SSSSS.BBBBBB.BBBBBB.SSSSS...#',
      '#..............................#',
      '###..........................###',
      '..#...........SSS............#..',
      '###...........SKS............###',
      '#KB...........SSS............BE#',
      '#.###......................###.#',
      '#3#.#......................#.#4#',
      '###.########################.###',
    ],
  },
  {
    id: 52,
    nome: 'Fácil 40',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '.....##......#####......##......',
      '.....#########...#########......',
      '......#K.#...#...#...#.K#.......',
      '......#..O.3.O...O...O..#.......',
      '.....###.#..###a###..#.###......',
      '.....#B#c##O#KF.HE#O##a#B#......',
      '.....###.#..###c###..#.###......',
      '......#..O.1.O...O...O..#.......',
      '......#K.#...#...#...#.K#.......',
      '.....#########...#########......',
      '.....##......#####......##......',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 53,
    nome: 'Fácil 41',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#...#..#................#..#...#',
      '#.1....#.#.....###.#..#.#....K.#',
      '#...#..#.#####.#.#.#..#.#..#...#',
      '#####..#..#..#.#.#.#..#.#..#####',
      '#...#..#.....#.#.#.#..#.#..#...#',
      '#.2....#.###E#.#.#.#..#.#....K.#',
      '#...#..###.###.###.#..#.#..#...#',
      '#####..#...........#..#.#..#####',
      '#...#.####.###.###.#..####.#...#',
      '#.3..T.....#.#.#.#.#....B....K.#',
      '#...#.####.#.#.#.#.#..####.#...#',
      '#####..#.###.#.###.#..#.#..#####',
      '#...#..#...........#..#.#..#...#',
      '#.4....#.###.####..#..#.#....K.#',
      '#...#..#.#.#.#..#..#..#.#..#...#',
      '#####..#.#.#.####.###.#.#..#####',
      '#...#..#.#............#.#..#...#',
      '#.5....#.###.########.#.#....K.#',
      '#...#..#................#..#...#',
      '################################',
    ],
  },
  {
    id: 54,
    nome: 'Fácil 42',
    dificuldade: 'facil',
    mapa: [
      '.......#################........',
      '......##....#.....#SSMS##.......',
      '.....##.....#..M..#SSTSS##......',
      '....##.T....B.#K#.B.TST..##.....',
      '...##.......#.....#.STS...##....',
      '..##........#..#..#........##...',
      '.########S#####B#####S########..',
      '...S.#.........K.........#.S....',
      '.###...#.....#.5.#.....#...###..',
      '...#########################....',
      '......###.....M.M.....###.......',
      '.....1##.......K.......##2......',
      '......#.T#############..#.......',
      '.....3#..#..T..B.....#..#4......',
      '......#..#.#########.#..#.......',
      '......#..#.#.B.B.B.#.#..#.......',
      '......#..#.#BKBSB.B#.#..#.......',
      '......#..#.#.BSESB.#.#..#.......',
      '......#..#.#..BSB..#.#..#.......',
      '......#..#.#.BKB.B.#.#..#.......',
      '......#...B#.........#..........',
    ],
  },
  {
    id: 55,
    nome: 'Fácil 43',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '........#####...................',
      '.......##...###.................',
      '.......#..T.T.###...............',
      '.......#TT.T..T.#...............',
      '.......#4TKT.T.T#...............',
      '.......#..S.TKS.#...............',
      '.......###.BETK##...............',
      '.........#K...##................',
      '.........###.K#.................',
      '...........####.................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 56,
    nome: 'Fácil 44',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '....TTTT.TTT...........TTT.T....',
      '...TT.T.T..T.........TTTTKTTT...',
      '...TTT.T.TTT.........T..TTK.T...',
      '...T.TT.TT.T..........TT..TTT...',
      '...TKTTKTT.T.........T..TT..T...',
      '....TTTTTTT..........TTTTTTTT...',
      '.......................TT.T.T...',
      '................................',
      '................................',
      '....TTTTTTT..........TTTTTT.T...',
      '...T.T.ETT.T........TTTT.TTTT...',
      '...TTTTT.TTT........TT..K.TTT...',
      '...T.T.T..TT........T.TTTTTTT...',
      '...TT.T.TTTT........TTT.....T...',
      '...TTTTT.TT.........TT.TTTTTT...',
      '................................',
      '.3..............................',
      '................................',
    ],
  },
  {
    id: 57,
    nome: 'Fácil 45',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#.1..........................5.#',
      '#..............................#',
      '#..............................#',
      '#.......B......................#',
      '#......BBBBB...................#',
      '#....BBB.B.BBBB................#',
      '#....B.BKTKB..B................#',
      '#....B.B.B.B.BB..........BBBB..#',
      '#....B.BBBBB.B.........BBB..B..#',
      '#....BBB...BEB.......BBB.B..B..#',
      '#..........BBB.......B.B.BBBB..#',
      '#...................BBBKBK.BB..#',
      '#...................BK..T.B.B..#',
      '#...................BBBBB#BBB..#',
      '#..............................#',
      '#..............................#',
      '#.4..........................2.#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 58,
    nome: 'Fácil 46',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#2.#.....KKK#.K##K.#KKK.....O.1#',
      '#.###########S####S###########.#',
      '###.....#####B.B.B.#####.....#O#',
      '#.#.###.###.#.T.T.T#####.###.#.#',
      '#.#4#S#.##..#BMB.B.#####.#S#3#.#',
      '#.#####.##..#5T.T.T#####.#####.#',
      '#..TK...#...############...KT..#',
      '#.#######...########..########.#',
      '#B#######....######...###..###B#',
      '#.######...B...##..B...##..B##.#',
      '#.####.....###....##......B###.#',
      '#..###.B....###.#..###...####..#',
      '#B..####.B....####...#B.####..B#',
      '##B..#####....#......######..B##',
      '#B#B..####.B............##..B#B#',
      '#.B.B..#####.........####..B.B.#',
      '#BKB.B..####.......B####..B.BKB#',
      '#KB.B#B..###B...B######..B#B.BK#',
      '#E.B.B#B..####BB######..B#B.B.E#',
      '################################',
    ],
  },
  {
    id: 59,
    nome: 'Fácil 47',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '........################........',
      '........#..............#........',
      '........#..........#E..#........',
      '........#..#######.##..#........',
      '........#..#.KKK.B.....#........',
      '........#..#B########..#........',
      '........#..#.#......#..#........',
      '........#.B#K..T.B..#..#........',
      '........#..#######BB#..#........',
      '........#1.........K#..#........',
      '........#..#####a####..#........',
      '........#..............#........',
      '........################........',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 60,
    nome: 'Fácil 48',
    dificuldade: 'facil',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '.....######################.....',
      '.....#....................#.....',
      '.....#.##O#####1.#####O##.#.....',
      '.....#.#KB.#...#O#..B..##.#.....',
      '.....#.#..B#K#....B.#B#.O.#.....',
      '.....#.#.B#.BB##.B..BB..#.#.....',
      '.....#.#B.#.#..K#..#K.B.#.#.....',
      '.....#.#B.B.#.B#.B.###.BO.#.....',
      '.....#.#...#.B..#.B.BBB.#.#.....',
      '.....#.#..#B..#.K###EB..#.#.....',
      '.....#.##B##O##O##.#O####.#.....',
      '.....#....................#.....',
      '.....######################.....',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 61,
    nome: 'Fácil 49',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#.T...........BKB.B.#MK###.....#',
      '#..####..##..B.B.B.B#...B......#',
      '#..S..S...#.#########..BBBM....#',
      '#...BB....#....#....#TBBBBBM...#',
      '#..S..S...####...##.SBBBBBBBM..#',
      '#.###########################3.#',
      '#.TB.##.BT.##.BT..M#......SM##S#',
      '#.##..M.##....##...#..M##..###.#',
      '################..4#..####.#2T.#',
      '##.S...S...S...S...#..#MM#.###.#',
      '#S...S...S...S...S.#BB#B.#.#...#',
      '#.##################..#.B#.#...#',
      '#...#.......#M..B..##.#BT#K#...#',
      '#.#.#.T.#.#.#..BBB.#..#T.#.#..B#',
      '#...#.B.#.5.#.T#S#.#.##BB#.#..B#',
      '##K###B###K##..#S#.#..#..#.###.#',
      '#...#...#...#.T#S#.##.#..#.#...#',
      '#.#.#.#.#.#.#..#S#.#..#T.#.#...#',
      '#.......#......#S#.#1.#..S.TB..#',
      '################E###############',
    ],
  },
  {
    id: 62,
    nome: 'Fácil 50',
    dificuldade: 'facil',
    mapa: [
      '################################',
      '#..............................#',
      '#............................5.#',
      '#..#########################...#',
      '#..#.B.B.B.B.B.B.B.B.BBB.B.#...#',
      '#..#.B.B.B.B.B.B.B.B.B.B.T.#...#',
      '#..#.B.T.B.B.B.T.B.B.T.B.B.#...#',
      '#..#.B.BKB.T.B.B.B.BKB.B.BK#...#',
      '#..#KB.BBB.BBB.BBBKBBB.B.BB#...#',
      '#..#BB.BBB.BBB.BBBBBBB.B.BB#...#',
      '#..###V#################Z###...#',
      '#..............................#',
      '#..............................#',
      '#.............###########......#',
      '######........#M.#.....F#......#',
      '#B...#........#T.e......##.....#',
      '#BBB.#........#..##O###O##.....#',
      '#B2BT.........BB.##O###O##..#..#',
      '#B1B.#........BB.a......#####..#',
      '#BBBB#........BB.#.....J#EBS...#',
      '################################',
    ],
  },
  {
    id: 63,
    nome: 'Médio 51',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '........################........',
      '........#.....B..#K#...#........',
      '........##d##BT..#B....#........',
      '........#K..#5B.......E#........',
      '........######.#####.###........',
      '.............#.#...#O#..........',
      '.............#.#...#.#..........',
      '........######O#####.###........',
      '........#KB..#...T...OK#........',
      '........###.##...B.B.###........',
      '........#4#......#.B...#........',
      '........#.B......#KB...#........',
      '........################........',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 64,
    nome: 'Médio 52',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#BTBTBTBTBTBTBTBTBTBTBTBTBTBT.B#',
      '#T############################T#',
      '#B#..#K.B.2#3#......#SS...S..#B#',
      '#T#..#####.#M#.T....#K#..#K#.#T#',
      '#B#..SSBT#.#B#####T####.####.#B#',
      '#T#..#####.#B...........#5.MT#T#',
      '#B#..#M....#.####.##########B#B#',
      '#T#..####T##.#..............##T#',
      '#B#.T........#.#.##########..#B#',
      '#T#..######.##.#..........##.#T#',
      '#B#..#....#.#..#B#.###S##.#M.#B#',
      '#T#..#.##.#...#K.#.#.TTS#.#B##T#',
      '#B#..#..#.#.##..##.#B...#.#M.#B#',
      '#T#.B##.#.#.#.B##..######.##.#T#',
      '#B#TK#.4#...#E.S.............#B#',
      '#T####B####.##########.#####.#T#',
      '#B#K.#.B.B#S............SMS..#B#',
      '#T##.....B#S##################T#',
      '#BTBT.BBB1#KBTBTBTBTBTBTBTBTBTB#',
      '################################',
    ],
  },
  {
    id: 65,
    nome: 'Médio 53',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#.B.B.B.B.#BB#BBBBM#.M..BBBSSSK#',
      '#B.B.B.BMB#TT#BBBB.#....TSSSSSS#',
      '#KB.B.B.B.#..#BB...#TTTTSSSSSSS#',
      '#B.B.B.B.BSTB#BB..B#BBBBSSMSSSS#',
      '#.B.B1B.B.#.T#BB..B.BBBBSSMMSSB#',
      '#B.B.B.B.B#.B#B..B.#.T..SSSSSST#',
      '#.B.B.B.B.#BB#5BBBB#....SSSSS.B#',
      '#B.B.B.B.B#B.####.B#....TBB.TBT#',
      '#.B.B.BKB.#..#EMMSB#.....TB.TBB#',
      '###########..#######.....BB..B.#',
      '#............BK#MMM#.....TBBBT.#',
      '#..#################.....BBBB..#',
      '#..#....S.#3#......#...........#',
      '#.B#.T....#.#..BBB.#...........#',
      '#.BB####.##.#..BBB.............#',
      '#B......BK#T#...TB.#.B.B.......#',
      '#.BTT..####.####.B.#B.B.......T#',
      '#.BB...T.TBS...B.B.#MB.B.....TB#',
      '#MBBB......B.......#BBB.....TBT#',
      '################################',
    ],
  },
  {
    id: 66,
    nome: 'Médio 54',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '...............#................',
      '..............###...............',
      '.............#.#................',
      '............#.....#.............',
      '...........S...#.S.#............',
      '..........SMSSS#S.S.............',
      '...........SS.SMSSKS.S..........',
      '..........MS.KSS.SMS.S#.........',
      '.......#..SMSS.#MSS.S..#........',
      '......#...SSKSS.SMS.S...#.......',
      '...........SS.S..SS.S..#........',
      '........#..S..SESSK.S...........',
      '..........SSS.S#SSSS.#..........',
      '..........SMSSMKSS..............',
      '...........#.SS#S...............',
      '..................#.............',
      '.............#4#.#..............',
      '..............#.................',
      '................................',
      '................................',
    ],
  },
  {
    id: 67,
    nome: 'Médio 55',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '........####....................',
      '......###K.###..................',
      '......#......#..######..........',
      '....###......####.K#.####.......',
      '....#4T......#..#.##..#K####....',
      '....#..####..B..#.....#...K#....',
      '....#13#..###BBB#B#.......##....',
      '....#K.#K....B..#E#.#####.#.....',
      '....#####....#..###K#.....#.....',
      '.......#....#####.####.B..#.....',
      '.......####...B...#..#.##K#.....',
      '..........#..#.##.#.....###.....',
      '..........#..#.#..B..#K.#.......',
      '.........##..#.##.#.K####.......',
      '.........#...#....####..........',
      '.........#K#K######.............',
      '.........#####..................',
      '................................',
      '................................',
    ],
  },
  {
    id: 68,
    nome: 'Médio 56',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#1......b.........#F#2.......dI#',
      '#.......#.#######.#W#.#....M.#.#',
      '#....#O##.#.....#.....########d#',
      '###..#....#.......#.#..........#',
      '#GY..#.####.#####.#.#######O#..#',
      '#K#..O.#........#.#.#Ka.#...#O##',
      '###a##.#.######.#.#.###.#.###..#',
      '#......#.#.HM.#.#.....#.#......#',
      '#..#####.#....#.#######.#.###..#',
      '#......#.#...3#.#.....#.#...#.5#',
      '######.#.#V#S##.#.#.###X#####Y##',
      '#....#.#..........#.....#..S.S.#',
      '##O#.#.##########.#####.#..#a#.#',
      '#..#.#..........#.#K#...#E.#K#O#',
      '#..#...##########.#S#.######O#.#',
      '#..##..#..........e.#..........#',
      '#...####.#####################d#',
      '###.O....YS.S.S.S...#..........#',
      '#Id.#....#B.#M#M#MKM#4.........#',
      '################################',
    ],
  },
  {
    id: 69,
    nome: 'Médio 57',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '.############......############.',
      '.############......############.',
      '.##..TKBB..##......##.B.B..BB##.',
      '.##.BBBB...##......##.BB...B.##.',
      '.##.B.TBT1.##......##..BB..BK##.',
      '.##.BBBB..#####..#####..B.BB.##.',
      '.##...B..##############4B.B..##.',
      '.###########......B2###########.',
      '.###......#.TBBBB.B..#......###.',
      '..........#.BBK.B.BBB#..........',
      '.###......#.B.BB.B...#......###.',
      '.###########....BB..###########.',
      '.##3...B.##############.B.B..##.',
      '.##..BBBT.#####..#####.BB.BB.##.',
      '.##.BBKT.B.##......##...BE.B.##.',
      '.##...BBBK.##......##..BB.BB.##.',
      '.##.....B..##......##5.B.B.B.##.',
      '.############......############.',
      '.############......############.',
      '................................',
    ],
  },
  {
    id: 70,
    nome: 'Médio 58',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#..............................#',
      '#.#######......................#',
      '#.#.....#.............######...#',
      '#.#KT...#........######K.B.###.#',
      '#.#####.#........#T.T#TBB....#.#',
      '#.#E.#..#........#5T.#....T.##.#',
      '#.#B.#..#..#########.#....###..#',
      '#.#BB#..#..#.T.T..T.......#....#',
      '#.#..#..####.....###.....4#....#',
      '#.#...........BB.T.#....###....#',
      '#.#.....#########BB.....#......#',
      '#.#######.......#####...#......#',
      '#...............#KB.###.#......#',
      '#...............#..B....##.....#',
      '#...............###BB.BB.#.....#',
      '#.................#.KBKB##.....#',
      '#.................#######......#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 71,
    nome: 'Médio 59',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#....................#B......SE#',
      '#....................O.......SS#',
      '#.....#..............#B........#',
      '#.....####.BBBB......##........#',
      '#......4.#.S..B.......#S##.....#',
      '#........#.B.SB#####.....#BM..B#',
      '#...######TBBBB....#.....###O###',
      '#...#.M.B.B..#K....#...........#',
      '#...#.M.B.BB.#.....#..####.....#',
      '#...##########.....#..#..#.....#',
      '#...........BBBBBBB####BB#.....#',
      '#...........B.....B....T.#.....#',
      '#....###BBBBB.....B....BK#.....#',
      '#....#..B..#########...T.#.....#',
      '#....#..B..#.......#...BB#.....#',
      '#....#K.B.K#.......#K..B.#.....#',
      '#....#######.......#######.....#',
      '#..............................#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 72,
    nome: 'Médio 60',
    dificuldade: 'medio',
    mapa: [
      '###########################E####',
      '#.12......#M#.........MSM#BSBS.#',
      '#.BB......#MSS........#MSBTBS..#',
      '#.B#......#K#..S......#SBSSS...#',
      '#BSB#.....####SMS######BS......#',
      '#BMSB.....#...SMS...######S#####',
      '#B..B.....#...B.B...BM#4SSS....#',
      '#B.B#.....#..T.B....TS#SBBBS...#',
      '#BBB#.....#SSBBBBB....#BTTTBS..#',
      '#BTB#.....#SSKKTTKBS#O#TBBBS...#',
      '#BMBT.....ST.BBT.B#...##TTT##S##',
      '#####SSSSS###.#.B.....#.SBMBS..#',
      '#.........#...S.SSSS..#.SBMBS..#',
      '#..T......#...#.SM#M#.#..SSS...#',
      '#.BB......#...#.SMSS..#........#',
      '#.BB......######.S....#####S####',
      '#BBB.......SKMM#..BBBBS...#SBSM#',
      '#BMBS....T######T.BMTBS...#.SBS#',
      '#BMBS.BBBBS.......BMBB#...ST.SB#',
      '#BBS..#M#M#......S.B..S...#...S#',
      '################################',
    ],
  },
  {
    id: 73,
    nome: 'Médio 61',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#T.#B...#B.#K#.................#',
      '#.......#..#.#.##..###...#.###.#',
      '#..###B......#.#.......#####.#.#',
      '#B...#B.....B#..#T#.####.1####.#',
      '###B.###.###B#......##...#KBB#.#',
      '#K##.....B.###.##.#.#..####..###',
      '#..#.B#..B.#.....###B.T...#...T#',
      '#B...B#...##...##.#..##...#....#',
      '#.#..B#...#...........#####....#',
      '###.....BB#....#...###.#..#.BBB#',
      '#...##.#####T..#..........B.B#B#',
      '#...#..#.B5###.#.........##..#T#',
      '#B..#......#B#.#.##.#.#...#..#.#',
      '#3.........#.#T#...........#...#',
      '####.........#TTTT##..#....###.#',
      '#4T#......#..#K#T#.........###.#',
      '#.K#.###d###.#.##2##..#..#...#.#',
      '#T.T.#...B.B.#..#T##..#.######B#',
      '#TTTT#E..B.B.#................B#',
      '################################',
    ],
  },
  {
    id: 74,
    nome: 'Médio 62',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.##..######B#1#.......##.####.#',
      '#.#......#K..#.#.#.###.#.....#.#',
      '#.#......#.BB....#..#..#.BB4.#.#',
      '#.#.#.##.###B....#..#..#BBB###.#',
      '#.#.#....#..B....#..#..#K.B..#.#',
      '#...#.#..#.#...#.T.....##..B.#.#',
      '#.....##.#O#...#.#..#..#.BBB.#.#',
      '#........#B#...#.#..#....B...#.#',
      '#.####.........#.#..#..#BBB###.#',
      '#.5..#...BBB...T...............#',
      '#....#.B.#B#...#....#.T...#....#',
      '#.#.##.#.#K#.####..##B#.#.###.##',
      '#.#....#B#B#...#...#KB..#.#....#',
      '#.#....#.#B#......##BBB...#BBBB#',
      '#.#.......BB.......#B.B...#..BB#',
      '#..T.............E..B.B...#B.B.#',
      '#.###.###..#..##.#.#B####.B.B..#',
      '#.........................#.BKT#',
      '################################',
    ],
  },
  {
    id: 75,
    nome: 'Médio 63',
    dificuldade: 'medio',
    mapa: [
      '#########........#############..',
      '#1......#........#...........#..',
      '#.......#####....#..BBBB.....###',
      '#.T#....#...#....####..##...B..#',
      '#..#.T..#...######..#...####B..#',
      '######.BBB...#.....BBB.K#...B..#',
      '.....#...B...BB....B..####..B###',
      '.....####B..BB.....B..#..#K.B..#',
      '........#..#..#########..###...#',
      '#####...#..#.K#..........#.BBB.#',
      '#BEB#...#######..........#.B.###',
      '#BBB###..................#.B.#.#',
      '#.....#..................#.....#',
      '#...B.#########....#########BBB#',
      '####B.#.......#....#.......#...#',
      '#...B.#.......######...........#',
      '#K..BBBB...BBBB.#..BB.BB.....###',
      '###..B..###B....BB.B.####....#..',
      '..#..B..#.BB...B#..B....######..',
      '..#######.......#......K#.......',
      '........#################.......',
    ],
  },
  {
    id: 76,
    nome: 'Médio 64',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#1M..#.............SMKSM5S.....#',
      '#....#S............SSSSSSS.....#',
      '#.S..#KS......................##',
      '#.MS#M#####.####.............#E#',
      '##B##.MB..#.B...###.........#.B#',
      '#...#.###M##.####..#########.B4#',
      '##S##M#M#S.#..3M#..........BBMB#',
      '#S..#...M#.######.##########.B.#',
      '#.S..###M#....M.S.#.........#.B#',
      '##....M#.########.#..........#.#',
      '#M###.B#M#KBS....#M...........##',
      '#2SSB..#.#B..#.....MSSSSSSSSSS.#',
      '#M###.B#M#S..B.....S..........S#',
      '##....S#.#KB..##...S.SSS###SS.S#',
      '#..S.B..B.#..#E#...S.SBB..BBS.S#',
      '#..S..S#S#####S#...S.SBKBKB.S.S#',
      '#BB.S.S#SSSSSSS#...SSSSS##SSS.S#',
      '#KKBS.S###########SS.B.B......S#',
      '#KKBS..B............SSSSSSSSSS.#',
      '################################',
    ],
  },
  {
    id: 77,
    nome: 'Médio 65',
    dificuldade: 'medio',
    mapa: [
      '....#.....#..................#..',
      '...##...BB#.................##BB',
      '...#.BBBBK#.................#B.B',
      '.###..B.###...............###K..',
      '.#.TBBB.#.................#M..BB',
      '.#5SST.E#.................#B.BB.',
      '.##SBB.##...............###BB..#',
      '..#....#................#..B.###',
      '..#...##................#BBB.#..',
      '..#.B.#...............###..B##..',
      '.##.B.#............####.....#...',
      '.#B.B.#............#..T....##...',
      '.#BTB.#............#BBB....#....',
      '##..B##............#KSB....##...',
      '#.BB.#.............##BB.T.B.#...',
      'MB...#..............#...BBBS#...',
      'B.B.2#..............#.T.B.SK#...',
      'B.B.##..............#.S.BB.##...',
      'B.###...............###.T.B#....',
      'K.#...................#....#....',
      '..#...................#...3#....',
    ],
  },
  {
    id: 78,
    nome: 'Médio 66',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '#......#####....................',
      '##...###K#.###..................',
      'K#...#.BB#..K#..................',
      '.#...#...#..####................',
      '.##..##S..SSS..#................',
      '..#...#S.......#####............',
      '..#...#MTB##.......###..........',
      '..#...#.BBK#.####....#..........',
      '..##..###..#..#.##...#......####',
      'SS.#....####..#....BB#......#...',
      '...######........##.B#...####..E',
      '......S#..........#K.##.##....##',
      '..#.T..B..#.......##B.###.T...#E',
      '#.###.BBBB##.####..BB.....##....',
      '#..3#.B.MB.###..##.........T..##',
      '##..#.B.####.....######.....###.',
      '.########.............#######...',
      '................................',
      '................................',
    ],
  },
  {
    id: 79,
    nome: 'Médio 67',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#KE#TT......................VM2#',
      '#KK#TT.############T############',
      '#B##TT.Z...B.......T.........BF#',
      '#1K#TT.#.##T####################',
      '#KK#TT.#.#B..TBF...............#',
      '#KG#TT.#.#T#####################',
      '#B##TT.#.#B#...................#',
      '#.T#TT.#.#T#.SSSSSSSSSSSSSSSSSS#',
      '#...TT.#...#.S.................#',
      '#...BB.V.###.S.SSSSSSSSSSSSSSSS#',
      '#...BB.#.#.V...SSSSSSSSSSSSSSSJ#',
      '#...BB.#.#.#.S.S.S.SSSSSSS.S.S.#',
      '#...BB.#.#.#.S.S.S.S354KKS.S.S.#',
      '#...B#.#.#.#.S.S.S.SSSSSSS.S.S.#',
      '#....B...#.#.S.S.............S.#',
      '#...BB.#.#.#.S.SSSSS.SSSSSSSSS.#',
      '#....B...#.#.S.................#',
      '#...BB.#.#.#.SSSSSSSSSSSSSSSSSS#',
      '#...BB.#.W.#...................#',
      '################################',
    ],
  },
  {
    id: 80,
    nome: 'Médio 68',
    dificuldade: 'medio',
    mapa: [
      '###.###.###.###.###.###.###.###.',
      '#K###.###.###.###.###.###.###K#.',
      '#S....B......B...B...........S##',
      '##B#.#B###K#.#..#.B###.........#',
      '.#.#.#..#.B#.#B#.#..#.........##',
      '##.#.#..#B.#.#.###..#.........#.',
      '#..#.#T.#M.#M#.#.#..#........B##',
      '##..#..###B.#..#.#..#........BK#',
      '.#........BB.................B##',
      '##............................#.',
      '#.............................##',
      '##.....................BB......#',
      '.#.....................B.B.T..##',
      '##......#.#..#..#...#..#B.###.#.',
      '#.......#.#.#.#.##.##B#.#BB#..##',
      '##......##..#.#.#M#M#B###..#B.2#',
      '.#......#.#.#.#.#.M.#.#.#.B#.B##',
      '##......#.#..#..#BBB#.#.#B.#BB#.',
      '#S..................T.........##',
      '#E###.###.###.###.###M###.###SK#',
      '###.###.###.###.###.###.###.####',
    ],
  },
  {
    id: 81,
    nome: 'Médio 69',
    dificuldade: 'medio',
    mapa: [
      'E#E#E#E#E#E#E#E##E#E#E#E#E#E#E#E',
      '#..............................#',
      'E..####E#####.########.######..E',
      '#..E#M##....E.#MB....#.#.M###..#',
      'E..##E#BBT....#B..E#.#.#BB####.E',
      '#..#.....####B###B.#S#.#...T.#.#',
      'E.T#..####..#.BM#..#K#.#.....#.E',
      '#..##.#.....#...#.#E##B#####.#.#',
      'E...#.E.TE#.#####.#M.B.....#.#.E',
      '#...#.....#.##....#.BT.....E.#.#',
      '#.##E..####..###..##TBB###...#.#',
      '#.#K#..#KS...#K#..##...#K#..##.#',
      'E.#S#..####.##S#..#....#S####..E',
      '#.#.#ET..M#.#.#E#TE....#.......#',
      'E.#.4.BB###.#.#.#...####.#####.E',
      '#.###BB.#..B#.##E####....#...#.#',
      'E...#...E...##B.....TBT###.ES#.E',
      '#...#...#..BB#M#####..M##..#K#.#',
      'E...#####....###.T.######.B###.E',
      '#.......................BB.B...#',
      'E#E#E#E#E#E#E#E##E#E#E#E#E#E#E#E',
    ],
  },
  {
    id: 82,
    nome: 'Médio 70',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.##T##..................#.###.#',
      '#.#......................#.....#',
      '#.B.###..................###.#.#',
      '#.###K#..................#B..#.#',
      '#BB...#...##B#####B###...B.T.#.#',
      '#...###...#BB......BB#...#B.##.#',
      '#BB##.....BB....#...BB...#.....#',
      '#.........#K###B###..#...###B..#',
      '#B###.#...#..#..#1#..#...#.###.#',
      '#.........#..#.E#B##.#...T..K#.#',
      '#B##.##...TB##.##.B.B....##B##.#',
      '#..#BBB...#BB......B.#...#..#..#',
      '#.K#..#...##B#########...#..##.#',
      '#B##BK#..................##B.#.#',
      '#.#.BT#......................#.#',
      '#.#......................#...#.#',
      '#...###..................#####.#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 83,
    nome: 'Médio 71',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.########..BBBBBBBB..BBBBBBBB.#',
      '#.#SSSSSS#..BBMB...B..BBMB.B.B.#',
      '#.#S#EK#S#..B..B.B.B..B..B.B.B.#',
      '#.#S####S#..BBBBBTBB..BBBBBBBB.#',
      '#.#SSSSSS#..B..T...B..B.B.B.MB.#',
      '#.#BBBBBB#..BBBBBBBB..BBBBBBBB.#',
      '#..............................#',
      '#..2...BBBBKB..BBBBTB..BBBBBB..#',
      '#......BB.BBB..B.B..B..BBBB.B..#',
      '#......BK.B.B..B..BBB..BMBMBB..#',
      '#......BKB..B..TBB.BB..BB.B.B..#',
      '#......BB..BB..B.BB.B..B.B.BB..#',
      '#......MBBB.B..B..BMB..BB...#..#',
      '#......BBKBBB..BTBBBB..BBBBBB..#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 84,
    nome: 'Médio 72',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '.....#####......................',
      '...###BB5#...#######............',
      '..##2..BB#...#K....#............',
      '..#.....B#...#####.#............',
      '..#...M.B#####.#.#B#............',
      '.##..BBBB..B.#.....#............',
      '.#...BSB..BBB#K#.#K#............',
      '.#4E.B..B.B.B###T####...........',
      '.#####BKBBB.BB......#...........',
      '.....#.BK.B.B.......##..........',
      '.....####.BBB........#..........',
      '........#B...........#..........',
      '........#......T....##..........',
      '........########....#...........',
      '...............#.T..#...........',
      '...............####.#...........',
      '..................###...........',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 85,
    nome: 'Médio 73',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#B.....B....M#.................#',
      '#..B.B..###..#..........#S#....#',
      '#.B#.####.####..........#K#....#',
      '#..#..................#######..#',
      '#BB######.###.........SK#S#KS..#',
      '#..B..BT#.#K##........#######..#',
      '#..B..BB#.#.............#K#....#',
      '###B#####.##............#S#....#',
      '#2#........#...................#',
      '#.#.#####.T#...#####...........#',
      '#.###B..####.......#...........#',
      '#..............###.#...........#',
      '#................#.#...........#',
      '#..............#.#T#####.......#',
      '#..............#T#3MT.4#.......#',
      '#..............#.#####M#.......#',
      '#BBB...........#5M..E#T#.......#',
      '#.BB..T.BB.....#######.#...T..B#',
      '#..B.B.BBBB............#.BB.BBB#',
      '################################',
    ],
  },
  {
    id: 86,
    nome: 'Médio 74',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '.......##BB#B#B#BBBBB#B#B.......',
      '.......BBB..K..B.B.KB.B.B.......',
      '.......#B.##.BB#.B.#.B..B.......',
      '.......B#BKBB#..B#..B.#.B.......',
      '.4.....BB..#..B.B..B.B..#.......',
      '.......B.#.#B#.K#.#..#.BB.......',
      '.......BB...K..BB..B.B..B.......',
      '.......#B.#BBB#..#.BBEB.B.......',
      '.......##BBB#B#BB#B#B#B#B.......',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 87,
    nome: 'Médio 75',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '..............#####.............',
      '..............#KBK#.............',
      '..............#BBB#.............',
      '.....#######..##.##.#######.....',
      '.....#.....#...#.#..#.....#.....',
      '.....#.....#####T####.BBB.#.....',
      '.....#2.T.............B.B.#.....',
      '.....#.....#####T####.B.B.#.....',
      '.....#.....#...#.#.K#.BTB.#.....',
      '.....#######...#.#.B#B...B#.....',
      '..............##.#.B#BBBBB#.....',
      '..............#..##K#.B.B.#.....',
      '..............#..K#B#.B.B.#.....',
      '..............#.B.#.#.B.B.#.....',
      '...........########T#.B.B.#.....',
      '...........#..........B.B.#.....',
      '...........#..E.....#.BBB.#.....',
      '...........##G#############.....',
      '............###.................',
      '................................',
    ],
  },
  {
    id: 88,
    nome: 'Médio 76',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#1.........#........#..........#',
      '#..........#........#..........#',
      '##.###.##..#........#..##.###.##',
      '#.......#..#BB....BB#..#.......#',
      '#BBBTBBB#..B.B....B.B..#BBBTBBB#',
      '#BBBBBBB#..B.B....B.B..#KBBKBBK#',
      '#.T.B.T.#..#BB....BB#..#BBTBTBB#',
      '#...B...#..#........#..#.......#',
      '##.###.##..#........#..##.###.##',
      '#..........#........#..........#',
      '#.........##..####..##.........#',
      '#.......###...#KK#...###.......#',
      '#......##.....#E.#.....##......#',
      '#......#.....BBB.BB.....#......#',
      '#......#.....B..B.B.....#......#',
      '#......#.....BBB.BB.....#......#',
      '#......#........B.B.....#......#',
      '#......#.....BBBBBB.....#......#',
      '#......#................#......#',
      '################################',
    ],
  },
  {
    id: 89,
    nome: 'Médio 77',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.##T#T#T#T#T#T##T#T#T#T#T#T##.#',
      '#.#..........................#.#',
      '#.T.2......................3.T.#',
      '#.#.........BB###............#.#',
      '#.T...####.B..#.......####...T.#',
      '#.#...#.#BBBB.#....BBB#..#...#.#',
      '#.T...T.#K....#....B..#..##..T.#',
      '#.#....B#######....B.B..BK#..#.#',
      '#.T..BT.#.....#...####BBBB#..T.#',
      '#.#..B..#..T..#...#K.#.T.....#.#',
      '#.T..BTB###..##...#B.#.BB##..T.#',
      '#.#..#....#..B...##.B##KBK#..#.#',
      '#.T..##..E#BBB.......B....#..T.#',
      '#.#...#####B.....BB..BBB###..#.#',
      '#.T.4......................1.T.#',
      '#.#..........................#.#',
      '#.##T#T#T#T#T#T##T#T#T#T#T#T##.#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 90,
    nome: 'Médio 78',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '..................#######.......',
      '...###########....#..#4.#.......',
      '..##1#B...B..#....#..#B.####....',
      '..#...B...B.#######.B.BB..B#....',
      '..#.B.B.##B.BB.#.K##....BBB#....',
      '..###.B.#.B.B.K#BB...##.B..#....',
      '..#.T.##########.....#E.####....',
      '..#...#..B..T..###T.#####..#....',
      '..#####BB...T..#....#...T..#....',
      '......#.BB##T########B...BM#....',
      '......###2#..#.TK#.B...S####....',
      '........####..T..#.B.S.##.......',
      '......###.B#..T.##..#...##......',
      '....###BBT.######..T#...B#......',
      '....#.BBB.TT.#T.#3..#.BTT#......',
      '....#K.B#.....B5######.SK#......',
      '....#############....#####......',
      '................................',
      '................................',
    ],
  },
  {
    id: 91,
    nome: 'Médio 79',
    dificuldade: 'medio',
    mapa: [
      '############################BBB#',
      '#1BK#..................T#B.KB.B#',
      '#BB........B.B..........##B.B.B#',
      '#.#.####..BBBBB.........#.B.B.B#',
      '#M###.T..B.B.B.B........B.BBB.B#',
      '###.....B..B.B..B.......#.....B#',
      '#.......B..B.B..B.....###.....B#',
      '#.......B..B.B........B..BBM..B#',
      '#........B.B.B......B..##BBB..B#',
      '#.........BBBBB.....BB.#...BB.B#',
      '#..........B.B.B....BBB.B.B.B.B#',
      '#..........B.B..B...#BB#.B.KB.B#',
      '#.......B..B.B..B...#####BBBB.B#',
      '#.......B..B.B..B..B..K#.B...BB#',
      '#.T.....B..B.B..B.###.B.B....B.#',
      '#.BB.....B.B.B.B....#..B.BBBBBB#',
      '#SBBB.....BBBBB..##B#..BB.....B#',
      '#SEBB......B.B....#...BBBBBB.BB#',
      '#SSBB.............##BBBBBB.B..K#',
      '####################B###########',
      '####################BB##########',
    ],
  },
  {
    id: 92,
    nome: 'Médio 80',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.......###....................#',
      '#.......#.#....................#',
      '#B......###...##############...#',
      '#..BB.........#BKBBBB##.B..#...#',
      '#BTBBB........#.BB..B##.BT.#...#',
      '#..TBT........#BB.B....B...#...#',
      '#K####........#K.B.BB##.B.B#...#',
      '###..#E.......#B.BB.B##B.B1#...#',
      '#.............##############...#',
      '#..............................#',
      '#..............................#',
      '#.....................##########',
      '#.....................#.......2#',
      '#T.......................B....B#',
      '#TTTTSSSS.............#B...BBBB#',
      '#TSS.B...B............#B.B.BBTT#',
      '#SSKSSBB.B............#TBBBB.B.#',
      '#SSSSSSBSS............#TMBT.TKT#',
      '################################',
    ],
  },
  {
    id: 93,
    nome: 'Médio 81',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '................................',
      '......####...####...............',
      '.....##..#...#..#...............',
      '.....#BTB#####T.##..............',
      '.....#2BBS...#...#..............',
      '.....##B...T....T#..#######.....',
      '......#S..###....####M....###...',
      '......#...T.#T...b..OB.BBBB.#...',
      '.....##B....#...3####B..#...#...',
      '.....#MB..####E###..#SKK###K#...',
      '.....###.##.........#####.###...',
      '.....#B...##....................',
      '.....#KB.BB#....................',
      '.....###.BB#....................',
      '.......#.BK#....................',
      '.......#####....................',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 94,
    nome: 'Médio 82',
    dificuldade: 'medio',
    mapa: [
      '..........#.#...........#.#.....',
      '..........#.#...........#.###...',
      '.##########.##..........#...#...',
      '.#.......#.K.#..........###.#...',
      '##.......##.##............#c#...',
      '.........3#a#............##.##..',
      '..#########.###########..#.B.#..',
      '..#..a.O......O.b..#..#..#...#..',
      '..1.#####b##a#####.2..#..#...#..',
      '..#.b.O........O.a.#..#..##.##..',
      '..#########.#########.#...#T#...',
      '..........#b#.....O.#.#####.####',
      '###S###..##.##....#...B.........',
      '.#K.#.#..#.K.#...####.#####.####',
      '.#K.#.#..#####...#..#.#...#c#...',
      '.##S###..........#.##.##.##.##..',
      '.#.......#...#...#.#MBM#.#.S.#..',
      '.##########.######.#.K.#.#.E.#..',
      '..........#.#......##.##.##.##..',
      '..........#.#.......#.#...#.#...',
      '..........#.#.......#.#...#.#...',
    ],
  },
  {
    id: 95,
    nome: 'Médio 83',
    dificuldade: 'medio',
    mapa: [
      '................................',
      '................................',
      '....########################....',
      '....#...............#......#....',
      '....#.#.###.#.#.###.#.##.#.#....',
      '....#.#..2#.#.#.#E#.#BK#.#.#....',
      '....#.#.###.#.#.#B#.#BB#.#.#....',
      '....#.#T...TKT#.#B#.#.##.#.#....',
      '....#.#K#####.#T#B#.#....#.#....',
      '....#..T........#B#.#.####.#....',
      '....#.#########.#.#.#.#....#....',
      '....#..........TKT..#.#.##.#....',
      '....#.###########.#.#.#.#KB#....',
      '....#B..............#.#.#BB#....',
      '....#.###############B#.##.#....',
      '....#B#....................#....',
      '....#.#.###T####T####B####.#....',
      '....#B.....................#....',
      '....########################....',
      '................................',
      '................................',
    ],
  },
  {
    id: 96,
    nome: 'Médio 84',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#..............................#',
      '#..#####...#####......#####....#',
      '#..#K..#...#..K#.....##...##...#',
      '#.##BB###.###BB##.....#T.T#....#',
      '#..#...........#.....##...##...#',
      '#.##BB###.###BB##.....#.E.#....#',
      '#..#K..#...#..K#......B...B....#',
      '#..#####...#####......#####....#',
      '#......T...T..........#...#....#',
      '#....#.#...#.#........#...#....#',
      '#..###.#####.###......#...B....#',
      '#..#..T..#..T..#....###B#####..#',
      '#..#.#.#.#.#.#.#....#...#...#..#',
      '#..#.###.#.###.#....#...#..K#..#',
      '#..#.2#5.#.3#1.#....#..B.BB.#..#',
      '#..#############....#########..#',
      '#..............................#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 97,
    nome: 'Médio 85',
    dificuldade: 'medio',
    mapa: [
      '################################',
      '#..............................#',
      '#.3............................#',
      '#..............................#',
      '#............#######.####.####.#',
      '#....#.########....#.#.TB.BK.#.#',
      '#.####.......##.##.#.#O##.##O#.#',
      '#.#....##.##.##.##.#.#.BT.BK.#.#',
      '#.#.##.##.##.##.##.#.####.####.#',
      '#.#.##.##.##TT.....#.#.BT.BK.#.#',
      '#.#...B.B....T##.###.#O##.##O#.#',
      '#.####.###.##.##.##..#.TB.BK.#.#',
      '#...##.###.##.##.##..####.####.#',
      '#...#.B......B..B##..#.TB.BK.#.#',
      '#...#K##.##.###B..#..#O##.##O#.#',
      '#...####.##.###.###..#.BT.BE.#.#',
      '#......#........#....####.####.#',
      '#......##########..............#',
      '#..............................#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 98,
    nome: 'Difícil 86',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#..........O.........O.........#',
      '#.#F.......##O##.##O##......F#.#',
      '#.###########..#.#..##########.#',
      '#.SKM.......O..#.#..O.....KV...#',
      '#.###########..#.#..##########.#',
      '#.O.......O....#.#....O......O.#',
      '#.##########O###O###O####.####.#',
      '#.#K..........O...O.......a.K#.#',
      '#O##########O###O###O###c#######',
      '#3.O......O.....1.........H.XaE#',
      '#O####a#####O###O###O###########',
      '#.#Kc...V.....O...O......X..K#.#',
      '#.##########O###O###O#########.#',
      '#.O.......O....#.#....O......O.#',
      '#.###########..#.#..##########.#',
      '#...XK......O..#.#..O......MKS.#',
      '#.###########..#.#..##########.#',
      '#.#H.......##O##.##O##......H#.#',
      '#..........O.........O.........#',
      '################################',
    ],
  },
  {
    id: 99,
    nome: 'Difícil 87',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#..............................#',
      '#..............................#',
      '#.......................#####..#',
      '#.......##########......#...#..#',
      '#...#####...B....#......#..K#..#',
      '#...#...B.B.B..B.#......#BBB#..#',
      '#...#EBBB.####BBB##....##...#..#',
      '#...##..B.#KKB....#....#KBBK#..#',
      '#....#.BBB##BB....#....#BBBB#..#',
      '#....#.B......T..5#....#...1#..#',
      '#....###3B..#.#####....#BB.##..#',
      '#......########........#.B.#...#',
      '#...................####.BB##..#',
      '#...................#...B..2#..#',
      '#...................#.B.B.B.#..#',
      '#...................#.TTTTTT#..#',
      '#...................##BBBBBB#..#',
      '#....................########..#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 100,
    nome: 'Difícil 88',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#....B...B..B.B...B..B.B...#...#',
      '#.BB.B....B..B...B.B.2BB...#BBB#',
      '#..#B.###################..#...#',
      '#BB#..#5B...K#...#.#.SSS#..#B..#',
      '#..#.##SB.####.T.....SES#..#.B.#',
      '#..#.#K.T.#......#B#.SSS#..B...#',
      '#BB#.#BBB.#.B#.B.#.#....#..#..B#',
      '#..#.#..B....#BBB#.##.###..#####',
      '#..#.#############.#.B..#..#...#',
      '#MB#..B...#..#.....##B..#..B..B#',
      '#BB###.##..B..BBBBB.#...#..#B.K#',
      '#T...#..B.#..#.........3#..##B##',
      '#B...####################B.#..B#',
      '#B.....B.................B.B..B#',
      '#B.B.T.B.B...............B.#..K#',
      '##.###B###B###B###B###B###.##B##',
      '#.BB#.BB#.BB#BB.#.BB#.BB#..B...#',
      '#B4TB......................B.BB#',
      '#BBM#BBB#.BB#BBB#BBB#BBB#BBBBK.#',
      '################################',
    ],
  },
  {
    id: 101,
    nome: 'Difícil 89',
    dificuldade: 'dificil',
    mapa: [
      '############....................',
      '#..#...BMB.##...................',
      '#.T#....BB..#...................',
      '#..SSSS....S#...................',
      '#.BBSS#TB.SE#...................',
      '#.SSSS#..BS##........##########.',
      '##.MS###B###......####..OBT...#.',
      '.#M.M#.....#......#K.#..#TBB..#.',
      '.##.##.SSS.#......#B.#4.#BT...#.',
      '.#.B.SSS#S.#......#BB#.#####BB##',
      '##B.BB###SS##.....#..#....O....#',
      '#....B#...SS#.....#..#######B#.#',
      '#....##..SSM#.....#BBB..T.#..#.#',
      '#M....B..S###....##...B...#..#.#',
      '##M2.M#...#......#B.BB..B##B.#.#',
      '.#######MM#......#...BB###...#O#',
      '.......####......##O##O#.K.B.#.#',
      '.................#.....TB##K##.#',
      '.................#BB.###.K###..#',
      '.................#BKB#.##......#',
      '.................#####..########',
    ],
  },
  {
    id: 102,
    nome: 'Difícil 90',
    dificuldade: 'dificil',
    mapa: [
      'E#######E######EE######E#######E',
      '#.......#......##......#.......#',
      '#..............................#',
      '#..##########################..#',
      '#..#..B.........#....#K#....#..#',
      '#..B.BBT........#....#S#....#..#',
      '#..#T...#S#.....#...........#..#',
      '#..#....#K#.....#....BB..T..#..#',
      'E#.#########....#.###B#.###.#.#E',
      '#..........###..#O#.#O#.#.#.#..#',
      '#..........#KS..#M#.#K#O#.#O#..#',
      '#..........###..#O#.#O#.#.#.#..#',
      'E#.#########....#.###B#S###S#.#E',
      '#..#....#K#..........B#..T..#..#',
      '#..#....#B#...........#..E..B..#',
      '#..#..................#.MSM.#..#',
      '#..#3.................#MSSSMB..#',
      '#..##########################..#',
      '#..............................#',
      '#.......#......##......#.......#',
      'E#######E######EE######E#######E',
    ],
  },
  {
    id: 103,
    nome: 'Difícil 91',
    dificuldade: 'dificil',
    mapa: [
      '###############..###############',
      '#.B...B.......#..#...........SM#',
      '#.#...#..#.M#.#..#.#...#..#.#MS#',
      '#.##.##.##S##.#..#.###S##B#.##.#',
      '#.#.B.#.B.SK#.#..#.#SSSS..#....#',
      '#.B.#..BBS.SS.#E.#SSSKSSS.#..#B#',
      '#.#.B...#######B.#######S....#.#',
      '#.##.#.##.B.BB.BB..#B.B##.####.#',
      '#....#.#B.B..BB.B.BWKB..#.....B#',
      '#.##.#.#.TBB..B.BB.#BB.B#..#.#O#',
      '#..#.#.#G1..BB.B..B.B.2F#.##.#.#',
      '#.B..BB#B..BB..B...B.B..#..B.#.#',
      '#.#O##O#.BBB#BB.B.BBBBB.#B#O##.#',
      '#O#..#.##.BKV..B.B.B..B##O#....#',
      '#..B.B..#######B.#######..###BB#',
      '#B.#.#........#.B#.....B.......#',
      '#..#.##.#..##.#..#S#..B####BBBB#',
      '#.##B...#..#SS#.K#S#M#..#......#',
      '###.BBB##.##SM#.B#M###..#.######',
      '#3.B...B..B.SM#.B#MMSS........4#',
      '###############BB###############',
    ],
  },
  {
    id: 104,
    nome: 'Difícil 92',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#SS..S.SS#.BM...#...SSSSSSSSSM5#',
      '#SM.SSSSSSMBB.B.#.B.S.......S.B#',
      '#..S.....S####BB#.B.S.SSSSS.SB.#',
      '#.#2.S.S...S#S.M#.B.S.S.4SS.S.B#',
      '#S.SSS.SSSS#MS..#E#####SMSS.S..#',
      '#SK#.....BBS.SBB#S..3..BBBS.S..#',
      '#S#S.SBSSSS..SB.##.####S.SS.SBB#',
      '#SKSMS.S###S.S###.M#MSSSMSS.SM.#',
      '#SSSS#S#.B.SBS..#M#...SSSSS.SM.#',
      '#####K#.B.BS.SS.###.BSSSSSS.S.B#',
      '#1#SKSS#.B.S....B.S.......B.SS.#',
      '#M#S##S#B.BSSSSS#.S.SSSSSSSSS..#',
      '#M#S##S#.B.B.B.B#.S.........BSB#',
      '#S#M##S#B.B.B.B.#.#.#SSSSSSSS..#',
      '#S#S##SS#B.B.B.B#.#T#......S..S#',
      '#K#E###M#.B.B.BSB.S#..SS.S...S.#',
      '#M#####M#B.B.BS.ES...S..SSSSS..#',
      '#MMKMM#M#.B.BS.M#.S....S...S..S#',
      '#####MKM#B.BS...#M.SSS...S...SM#',
      '################################',
    ],
  },
  {
    id: 105,
    nome: 'Difícil 93',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#M12345SSSSSSSSSSSSSSSSSSSSSSSS#',
      '#SSSSS.SM.S.####.####.####.#..##',
      '#......ST.S.#....#..#.#....#..##',
      '#.SSSSSS..S.#....#..#.#....#..##',
      '#.SE......S.####.####.####.#####',
      '#.S.......S.#....#..#....#....##',
      '#.S.........#....#..#....#....##',
      '#.SSSSSSSSS.####.#..#.####.#####',
      '#.SM.BB...S....................#',
      '#.S..BBBS.S.SSSSS.SSSSS.SSSSSSS#',
      '#.SB.BB.S.S.S...S.SSSSS.S###BBS#',
      '#.S.BBB.S.S.S...S.S.S.S.ST#BT.S#',
      '#.S..BB.S.SSSSSSS.S.SBS.SB.BBBS#',
      '#.S..BB.S.SSSSSSS.S...S.S.B...S#',
      '#.SBB.B.S.S.SMSSS.S...S.S..##.##',
      '#.S..B..S.S.SMSSS.S..SS.S..#KB##',
      '#.SSSSSSS.S.SMSSS.SKKKS.S..##.##',
      '#.........S.SMSSS.SSSSS.S...#K##',
      '#SSSSSSSSSS.SSSSS.SSSSS.SSSS####',
      '################################',
    ],
  },
  {
    id: 106,
    nome: 'Difícil 94',
    dificuldade: 'dificil',
    mapa: [
      '................................',
      '................................',
      '..#######.......................',
      '..#BSSBK#..##################...',
      '..###.###..#5SBT.TKBKKS.S..T#...',
      '....#.#....#.SBT.SSBSSS..S..#...',
      '..###.###..#.SB..BSBS.S.B.S.#...',
      '..#1MBM2#..#MST.BBSBS.S...S.#...',
      '..###T###..#BS...BSBS..S.S..#...',
      '....#3#....#.T...#SBS.##.S..#...',
      '....###....#.BB...BB.#...#..#...',
      '...........#BBBBBSSBS##TT...#...',
      '....###....#B.S.SSS......#S.#...',
      '....#K#....#B.S...S.SSSTT.S.#...',
      '..###S###..#.....TS.#.#...S.#...',
      '..#KS4SE#..#..T#....STS##.S.#...',
      '..###M###..#.TBBSSS.......ST#...',
      '....#M#....##################...',
      '....###.........................',
      '................................',
      '................................',
    ],
  },
  {
    id: 107,
    nome: 'Difícil 95',
    dificuldade: 'dificil',
    mapa: [
      '..############################..',
      '..#..........................#..',
      '###..........................###',
      '#......#####...................#',
      '#......#...######..########....#',
      '#...####....T...#..#.....2#....#',
      '#...#1......T...####.BB.B##....#',
      '#...##......T...#B...#.BK#.....#',
      '###..#..#####...##B..###B#...###',
      '..#..#..T..K#....#.......###.#..',
      '..#..#..T..##.....B#.......#.#..',
      '..#..####..#K..#...##.B##BB#.#..',
      '###.....#..#####..B.#.BKEK.#.###',
      '#.......##.....T..###.B##B##...#',
      '#........#.....T..#.#..#.B#....#',
      '#........#.....####.#..BB.#....#',
      '#........#.....#....##....#....#',
      '#........#######.....######....#',
      '###..........................###',
      '..#..........................#..',
      '..############################..',
    ],
  },
  {
    id: 108,
    nome: 'Difícil 96',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#BTB.T.B.#...T............#.#BE#',
      '#T2....T.#.TT.............BBB3B#',
      '#B.....B.#TT..............#B#B##',
      '#.T....B.BKT..............#KBB.#',
      '###....T##TT..............###B##',
      '#KW....T.#.....................#',
      '#T#TT.BBG########..............#',
      '##########KBBBBB###............#',
      '#B....BMB#..B.B.BB.............#',
      '#.BB.B.B.#BBB.B.BB#............#',
      '#..B.B..B#BBB.B.###............#',
      '#..BBBBBB#......#..............#',
      '#..BKBB..#.B....#..............#',
      '#..B..B..#B..B..#..............#',
      '#..BBKB.S#BBBB.B#..............#',
      '#..BBBB.SB..BBB.###.###........#',
      '#.......SB..BB..#.....#.......T#',
      '#.1.....S#TBB...#B###B#......T.#',
      '#........#T.TTTT#..K..#.....BTT#',
      '################################',
    ],
  },
  {
    id: 109,
    nome: 'Difícil 97',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#EB.B..#..4#...B..#K#SSS#.....3#',
      '#BT.B..#...#BB.B.T#M#S.S#......#',
      '#..BB..#...#.BBB..#S#K.S#......#',
      '#BBB...#...#...B..#.###SBM.....#',
      '#......#...#BBBB..#.....#......#',
      '#...BB.B...#....B.#.....#.BBB..#',
      '#......#...#...BBB#.....#B.B.BB#',
      '###BB###...#...B..#.....###B####',
      '#..........#.T.B..#.....#......#',
      '#..........######.#.....#......#',
      '#..........B.O.2#.#.BBB.#BB..BB#',
      '#...B#BB...####.#.#.BBB.#KB..BK#',
      '#..BB..BB..#..#.#.#.B.B.#.B..B.#',
      '#..BKTTMB..#T.#...B..B..BBBBBBB#',
      '#..BB..BB..#..#####.B.B.#......#',
      '#...BB#B...#......#.BBB.#......#',
      '#..........B......#.BBB.#......#',
      '#..........#......#.....#......#',
      '#..........#1.....#.....#.....5#',
      '################################',
    ],
  },
  {
    id: 110,
    nome: 'Difícil 98',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#53.......BB.#......##MBBBBBBBE#',
      '#..#..T......#.####.B..B...T...#',
      '#########B##B#.#..#.#..##......#',
      '#........B...#......#...#......#',
      '#B......######.######...#.....K#',
      '#.SB...##...........#...#.....K#',
      '#BMS..T#............##..#.....K#',
      '#.BB...#............#...#......#',
      '######S#######...BSS#...#......#',
      '#M.K.B.S.....####BSS#T..#......#',
      '#.#.##.#.....S..#.SS#..SBB.....#',
      '#..B.#.#...BB####BSS#...#......#',
      '#B.B.#.#.....#KS....#.#.#......#',
      '#.B.B#.#B.BBB#SS...M#..B#......#',
      '#.B.B#.#..B..#....###.B.#......#',
      '#B.B.#.#.B..T#....#.B..B#......#',
      '#B...#.#.B.B.#....#.....#......#',
      '#..BB#.#B...B#...T#BB..T#......#',
      '#BB....#M.B..BB..M#M#...#......#',
      '################################',
    ],
  },
  {
    id: 111,
    nome: 'Difícil 99',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#...................#E.STT.T.T.#',
      '#.#########.BBBB###T#.S..T.T.T.#',
      '#.#M..........B##B.B##....T.TTT#',
      '#.#MS#SSS##BB#.##T###T####T.T.T#',
      '#.#M.#.S##..B#..#....B...#TTTTT#',
      '#.#SS#S.#..B.#.T#BB.BB.B.#..5..#',
      '#.#..#S.#BBB.#..#.B.BB.BB#TTTTT#',
      '#.#SS#..#...##.T#BB.B.B..#TTT..#',
      '#.#S.#SS#.S.#MBB#..B.B.BB#M....#',
      '#.#S#...#BB.#2B.#.B.B4B..#SSSSS#',
      '#.#.#.#BB.BB##B.#..B.B...#..MS.#',
      '#.#...#.B.B..#B.#.BBBBBB.#.SSST#',
      '#.#.###.#BB###.B#...B..BB#..SS.#',
      '#.#.#B#.B..#B.B.#.B...B..#KSSSK#',
      '#.#.#1.M#.B#.BB.#..BB.##########',
      '#.#.#B#B#.B#.B.B###S#S#.S......#',
      '#.#.###.BB.##.##..#KKK#M..####.#',
      '#.#...#.B.....BB..#####.B##TT#.#',
      '#.....#..BBB.B...B..E..S3#KB.T.#',
      '################################',
    ],
  },
  {
    id: 112,
    nome: 'Difícil 100',
    dificuldade: 'dificil',
    mapa: [
      '#########.......................',
      '#.......#.......................',
      '#.BB..5.#.......................',
      '#.BMB...#.......................',
      '#.BBB...#.......................',
      '#.BMB...#.......................',
      '#..BB...#####...................',
      '#.........BB#...................',
      '#.3.......BB###.................',
      '#.##.##...MBBB#.......##########',
      '#.##.##.##B.B.#########...K#..K#',
      '#.......#SB.T.BB......S.##S#.###',
      '#.##.##..B..B.BB......#K#K....K#',
      '#.##.##.BB.B.BB.......##########',
      '#......#####.B.................#',
      '########...#.BB................#',
      '...........#BBB...........#E#..#',
      '...........#B...T.........EEE..#',
      '...........##########.....#E#..#',
      '....................#..........#',
      '....................############',
    ],
  },
  {
    id: 113,
    nome: 'Difícil 101',
    dificuldade: 'dificil',
    mapa: [
      '.T...B..#.........##############',
      '.##.BB.##.........#...B.B....B.#',
      '..######..........#.KB..B..BB.B#',
      '###...............#.B.B.##...T3#',
      '..................##.B...##.####',
      '...................#T###.#...BK#',
      '....############...#.B.#B##.#B##',
      '....#..#...#B..#...#..T.4BB.T..#',
      '..###.B#.BTS.KB#...##.########B#',
      '..#.TB.....#.BB#....#B.B....#..#',
      '..#....#...#B.E#....#.T.B.#.#T.#',
      '..##.###B.B#B###....#####...#.B#',
      '..#...#2.BBBM#......#.....T##.##',
      '..#B..######.#......#.#BB..#.B.#',
      '..###.B.#1...#......#.#K#.##BB.#',
      '....#.######.#......#.###.#K.TB#',
      '....#......T.#......#.....#BTBB#',
      '....##########......############',
      '................................',
      '................................',
      '................................',
    ],
  },
  {
    id: 114,
    nome: 'Difícil 102',
    dificuldade: 'dificil',
    mapa: [
      '........................#.B...#.',
      '........................####B.##',
      '...#########.....#####.....#.BB.',
      '...#..#KB..#######...#.....#G.##',
      '...#T.#MB........OT.K#.....####.',
      '...#K.##B....#####..#####.......',
      '..##T..#....M#K..#..BSBE#.......',
      '..#......#####T..##.SBSB#.......',
      '..#.1....O........###SBS#.......',
      '..#...##########....#.SB#..#####',
      '..#####........#........#..#..W.',
      '..............##..###O###..#.T#B',
      '..............#...#.....#..#..#.',
      '..............#...O..5..#..##.##',
      '..............#...#K...M#...#.#.',
      '####..........###########...#.#.',
      '...#........................#.X.',
      '...########.................#.##',
      '.T...T....#...............###..B',
      '.#BB.BH...#...............#..B.B',
      '.#...##...#...............#.BB##',
    ],
  },
  {
    id: 115,
    nome: 'Difícil 103',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#5......#M.M.M.M#..............#',
      '#######.#..BBB..#......BBBBBB..#',
      '#MM..B#.#M.BTB.M#.....B.BB..TB.#',
      '###..B#.#..BBB..#.....B.B.KBBB.#',
      '#M#..M#.#M.M.M..#.....BB.B.B.B.#',
      '#3BBT##.#######.#......BBBBB.B.#',
      '#M#MB##.......#.#..........BBB.#',
      '###.#########.#.#BB............#',
      '#SB...##..MB#.#.#BBB...........#',
      '#S#.#M...BBB#...######BBBB.....#',
      '#SBB#########.########BBBB.....#',
      '#SSSS.........#...##....BB.....#',
      '#SSSSS#########.#.##T...BB.....#',
      '#S##SS#4#######T#.##.BBB##.....#',
      '#S##SS#.B.......#.##B...##.....#',
      '#SSSSS#BEB#BBBB.........##.....#',
      '####SS#BBB#T...T#######BK#....T#',
      '####SSSS###TTKTTBBBBBBB..#BB.BB#',
      '#KSSSSSS#TTTTTTTBBBBBB...#K.BBB#',
      '################################',
    ],
  },
  {
    id: 116,
    nome: 'Difícil 104',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#.........B..........#.........#',
      '#K###B####BBB..T.....#.........#',
      '##EM#......########.##.#####...#',
      '#...#..................#...B...#',
      '#.###SSSSSSSSBBBB.#.#.##3.M#...#',
      '#.#BBBBBBBBBSSS.B.#.#..#####...#',
      '#S#BBBBBBBBBB.SSB.#BBBB........#',
      '#.S........BB..S..#....#.....###',
      '#.S.S.BBBB.BBBBS..########.....#',
      '#.S.S.BBBBBBBBBS...............#',
      '#.S.S.BB..B..BBSSSSS......#S#..#',
      '#.S.S.BBBBBB.BB...TS..TTT.#B#..#',
      '#.S.S.BBB.KB.BBBBB.S......#.#..#',
      '#.S.S.BB...B.BBBBB.S......#.#..#',
      '#.S.S.BB.BBB.....BTS.######.#..#',
      '#.S.S.BB.BKBBBBBBB.S.#......#..#',
      '#.S.S....B..B.K..B.SS#.######TT#',
      '#.S.BBBBBBBBBBBBBBBBB#.#BK.#BBT#',
      '#...BBBBBBB..........#..TB.#MBT#',
      '################################',
    ],
  },
  {
    id: 117,
    nome: 'Difícil 105',
    dificuldade: 'dificil',
    mapa: [
      '################################',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#.BB...BB......................#',
      '#BBBBB.BBBBBB..........BB......#',
      '#BKBBT.TKB.BB.......BBBBBB.....#',
      '#..BBBBBBBBBB.......BBBB.BB....#',
      '#BBB.BBB...........BBK...BB....#',
      '#BBB1.BBBBBB.......BBBBBBBB....#',
      '#.TBB.T..BBB.........B...BB....#',
      '#B.BBBBB...B.........BBBBB.....#',
      '#B..BB.BBBBB.........BBBBB.....#',
      '#.BB..BBB......................#',
      '#.....BB.......BBBBB...........#',
      '#..............B.B.B...........#',
      '#...........BBBB.B.BBBB........#',
      '#...........B...B.B...B........#',
      '###.........B.BB.B.BB.B........#',
      '#E..........B..BKBKB..B........#',
      '################################',
    ],
  },
  {
    id: 118,
    nome: 'Bônus 11',
    dificuldade: 'expert',
    mapa: [
      '################################',
      '#..............................#',
      '#.#####..###....#..#####..###..#',
      '#...#...#...#.1##..#...#.#...#.#',
      '#...#...#...#...#......#.#.....#',
      '#...#...#...#...#.....#..####..#',
      '#...#...#...#...#....#...#...#.#',
      '#...#...#.#.#...#...#....#...#.#',
      '#...#...#.E##...#..#.....#...#.#',
      '#.#####..###...###.#......###..#',
      '#..........##..................#',
      '#..............................#',
      '#..............................#',
      '#..............................#',
      '#..#.#.##..#.#..#.#.####.#.###.#',
      '#.#.#####..#.#.#.##.##..#.#.#..#',
      '#.#.#####...#..#..#####.###.#..#',
      '#.#.#####...#..#.##K##..#K#.#..#',
      '#..#K#K####.#...#K#.#####.#.#..#',
      '#..............................#',
      '################################',
    ],
  },
  {
    id: 119,
    nome: 'Bônus 12',
    dificuldade: 'expert',
    mapa: [
      '################################',
      '##............................##',
      '#..............................#',
      '#.......................SSSS...#',
      '#...###########...###..S....S..#',
      '#...#K#K#K#K#K#...#E#.S......S.#',
      '#...#.#.#.#.#.#...#1#........S.#',
      '#...B.T.T.T.T.B..............S.#',
      '#...#.#.#.#.#.#.............S..#',
      '#...#.#.#.#.#.#.........SSSS...#',
      '#...#.#.#.#.#.#........S.......#',
      '#...#B#B#B#B#B#.......S........#',
      '#.....................S........#',
      '#.....................S......S.#',
      '#......................S....S..#',
      '#.......................SSSS...#',
      '#..............................#',
      '#........................SS....#',
      '#........................SS....#',
      '##............................##',
      '################################',
    ],
  },
  {
    id: 120,
    nome: 'Bônus 13',
    dificuldade: 'expert',
    mapa: [
      '####BBBBB####B######BBBBBBBB####',
      '#K.#.....#.K#.#.....#.......#..#',
      '#..#.....#..#.#......#......#..#',
      '#..#.....#..#.#..##...#.....#..#',
      '#..#.....#..#.#..#.#...#....#..#',
      '#..#.....#..#.#..#..#...#...#..#',
      '#..#.....#..#.#..#...#...#..#..#',
      '#..#.....#..#.#..#....#...#.#..#',
      '#BB#.....#BB#.#BB#.....#BBB##BB#',
      '#..#.....#..#.#..#......#..E#..#',
      '#..#.....#..#.#..#.......#.....#',
      '#BB#.....#BB#.#BB#........#BBBB#',
      '#..#.....#..#.#..#.........#...#',
      '#..#.....#..#.#..#..........#..#',
      '#..#.....#..#.#..#..........#..#',
      '#..#.....#..#.#..#..........#..#',
      '#...#...#...#.#..#..........#..#',
      'B#...###...#..#..#..........#..#',
      'B.#K.....K#...#..#..........#..#',
      'B..#..1..#....#K.#..........#.4#',
      'BBBB#####BBBBB####BBBBBBBBBB####',
    ],
  },
  {
    id: 121,
    nome: 'Bônus 14',
    dificuldade: 'expert',
    mapa: [
      '####BBBBBBBBBBBBBB####BBBBBBBBBB',
      '#..#..............#..#.........B',
      '#..#..............#..#K........B',
      '#######........##########......B',
      'B..#..#........#..#..#..#......B',
      'B..#..#K.......#..#..#..#......B',
      'B..#######..#######..#######..##',
      'B.....#..#..#..#........#..#..#.',
      'B.....#..#4.#..#........#..#5.#.',
      'B.....##########........########',
      'B........#..#..............#..#B',
      'B.......K#..#1............K#..#B',
      'B.....##########........########',
      'B.....#..#..#..#........#..#..#.',
      'B.....#..#..#..#........#..#..#.',
      'B..#######..#######..#######..##',
      'B..#..#........#..#..#..#......B',
      'B3.#..#........#..#..#..#......B',
      '#######........##########......B',
      '#..#2............E#..##.......KB',
      '#..#BBBBBBBBBBBBBB#..#BBBBBBBBBB',
    ],
  },
  {
    id: 122,
    nome: 'Bônus 15',
    dificuldade: 'expert',
    mapa: [
      '................................',
      '................................',
      '................................',
      '................................',
      '....########################....',
      '....##....###..KK..###....##....',
      '....#......#...TT...#......#....',
      '....#.T..T.#4.......#.T..T.#....',
      '....#.#BB#.####..####.#BB#.#....',
      '#######..###EK#KK#KE###..#######',
      '......#2.#.#KKBBBBKK#.#.1#......',
      '#######..###EK#KK#KE###..#######',
      '....#.#BB#.####..####.#BB#.#....',
      '....#.T..T.#.......5#.T..T.#....',
      '....#......#...TT...#......#....',
      '....##....###..KK..###....##....',
      '....########################....',
      '................................',
      '................................',
      '................................',
      '................................',
    ],
  },
];
